{
  "meta": {
    "version": "tase-index-explorer-2026-07-07-r2",
    "asOfDate": "2026-07-07",
    "generatedAt": "2026-07-07",
    "title": "TASE Index Constituents Explorer",
    "description": "Static research dataset for inspecting Israeli public-market index constituents, concentration, sector exposure, and strategic themes.",
    "sourceMode": "curated-static-seed",
    "liveDataWarning": "This is not a live TASE quote or official real-time constituent feed. Verify current constituents and weights with TASE or a licensed data vendor before using the data operationally.",
    "dataDirectory": "data/tase-index-explorer"
  },
  "indices": [
    {
      "id": "ta-35",
      "name": "TA-35",
      "taseId": "142",
      "family": "Large cap equity",
      "description": "Large-cap benchmark for the most liquid shares in the TASE Tamar universe. The local dataset tracks 35 large constituents with normalized research weights.",
      "expectedConstituentCount": 35,
      "coverage": "curated-full-count",
      "weightSource": "curated-normalized",
      "weightCapPct": 7,
      "sourceUrl": "https://market.tase.co.il/en/market_data/index/142/about",
      "methodologyNote": "Use this lens to inspect large-cap concentration, finance exposure, technology weight, and strategic public-market anchors.",
      "constituentCount": 35,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 100,
      "sourceTypes": [
        "curated-normalized"
      ],
      "top5WeightPct": 35,
      "top10WeightPct": 56.4,
      "top20WeightPct": 79.8,
      "hhi": 425,
      "profileLinkCount": 5,
      "dualListedCount": 9,
      "sectors": [
        {
          "label": "Finance",
          "weightPct": 37.3
        },
        {
          "label": "Technology",
          "weightPct": 23.9
        },
        {
          "label": "Energy",
          "weightPct": 12.5
        },
        {
          "label": "Real Estate",
          "weightPct": 12.35
        },
        {
          "label": "Healthcare",
          "weightPct": 7
        },
        {
          "label": "Consumer",
          "weightPct": 3.45
        },
        {
          "label": "Communications",
          "weightPct": 1.75
        },
        {
          "label": "Materials",
          "weightPct": 1.75
        }
      ],
      "industries": [
        {
          "label": "Banks",
          "weightPct": 24.15
        },
        {
          "label": "Insurance",
          "weightPct": 13.15
        },
        {
          "label": "Defense electronics",
          "weightPct": 7
        },
        {
          "label": "Pharmaceuticals",
          "weightPct": 7
        },
        {
          "label": "Semiconductors",
          "weightPct": 7
        },
        {
          "label": "Income properties",
          "weightPct": 6.55
        },
        {
          "label": "Semiconductor equipment",
          "weightPct": 6.25
        },
        {
          "label": "Renewable energy",
          "weightPct": 3.3
        },
        {
          "label": "Oil and gas exploration",
          "weightPct": 3.05
        },
        {
          "label": "Power generation",
          "weightPct": 2.9
        },
        {
          "label": "Defense electro-optics",
          "weightPct": 2.15
        },
        {
          "label": "Retail and mixed-use properties",
          "weightPct": 1.9
        }
      ],
      "themes": [
        {
          "label": "Financial system",
          "weightPct": 37.3
        },
        {
          "label": "Critical services",
          "weightPct": 29.95
        },
        {
          "label": "Banks",
          "weightPct": 24.15
        },
        {
          "label": "Infrastructure",
          "weightPct": 17.85
        },
        {
          "label": "Technology",
          "weightPct": 16.9
        },
        {
          "label": "Semiconductors",
          "weightPct": 13.25
        },
        {
          "label": "Insurance",
          "weightPct": 13.15
        },
        {
          "label": "Energy",
          "weightPct": 12.5
        },
        {
          "label": "Real estate",
          "weightPct": 12
        },
        {
          "label": "Defense",
          "weightPct": 9.15
        },
        {
          "label": "Defense resilience",
          "weightPct": 9.15
        },
        {
          "label": "Electronics",
          "weightPct": 9.15
        }
      ],
      "topConstituents": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7,
          "sector": "Technology",
          "profilePath": "/startup-elbit-systems"
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7,
          "sector": "Healthcare",
          "profilePath": ""
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7,
          "sector": "Technology",
          "profilePath": "/startup-tower-semiconductor"
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45,
          "sector": "Technology",
          "profilePath": "/startup-nova-ltd"
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-90",
      "name": "TA-90",
      "taseId": "137",
      "family": "Mid cap equity",
      "description": "Mid-cap benchmark for shares below the TA-35 tier. The local dataset covers a representative research universe used for overlap and sector analysis.",
      "expectedConstituentCount": 90,
      "coverage": "curated-sample",
      "weightSource": "curated-normalized",
      "sourceUrl": "https://market.tase.co.il/en/market_data/index/137/about",
      "methodologyNote": "Use this lens to inspect the broader operating-company layer below the largest banks, insurers, pharma, defense, and technology names.",
      "constituentCount": 42,
      "trackedCoveragePct": 46.7,
      "knownWeightTotal": 100.05,
      "sourceTypes": [
        "curated-normalized"
      ],
      "top5WeightPct": 23.52,
      "top10WeightPct": 40.97,
      "top20WeightPct": 68.74,
      "hhi": 307,
      "profileLinkCount": 4,
      "dualListedCount": 7,
      "sectors": [
        {
          "label": "Energy",
          "weightPct": 27.02
        },
        {
          "label": "Real Estate",
          "weightPct": 21.84
        },
        {
          "label": "Technology",
          "weightPct": 16.94
        },
        {
          "label": "Finance",
          "weightPct": 11.37
        },
        {
          "label": "Consumer",
          "weightPct": 9.18
        },
        {
          "label": "Industrials",
          "weightPct": 8.4
        },
        {
          "label": "Communications",
          "weightPct": 5.3
        }
      ],
      "industries": [
        {
          "label": "Renewable energy",
          "weightPct": 14.99
        },
        {
          "label": "Income properties",
          "weightPct": 10.73
        },
        {
          "label": "IT services",
          "weightPct": 6.46
        },
        {
          "label": "Telecommunications",
          "weightPct": 5.3
        },
        {
          "label": "Holding company",
          "weightPct": 4.78
        },
        {
          "label": "Market infrastructure",
          "weightPct": 4.65
        },
        {
          "label": "Food retail",
          "weightPct": 4.4
        },
        {
          "label": "Infrastructure and contracting",
          "weightPct": 3.88
        },
        {
          "label": "Oil and gas exploration",
          "weightPct": 3.75
        },
        {
          "label": "Fuel and retail infrastructure",
          "weightPct": 3.62
        },
        {
          "label": "Payments infrastructure",
          "weightPct": 3.23
        },
        {
          "label": "Construction and real estate",
          "weightPct": 3.1
        }
      ],
      "themes": [
        {
          "label": "Infrastructure",
          "weightPct": 38.64
        },
        {
          "label": "Critical services",
          "weightPct": 36.33
        },
        {
          "label": "Energy",
          "weightPct": 27.02
        },
        {
          "label": "Real estate",
          "weightPct": 21.84
        },
        {
          "label": "Technology",
          "weightPct": 16.94
        },
        {
          "label": "Renewables",
          "weightPct": 14.99
        },
        {
          "label": "Consumer",
          "weightPct": 14.87
        },
        {
          "label": "Software",
          "weightPct": 11.38
        },
        {
          "label": "Financial system",
          "weightPct": 11.37
        },
        {
          "label": "Construction",
          "weightPct": 9.69
        },
        {
          "label": "Industrial inputs",
          "weightPct": 8.79
        },
        {
          "label": "Market infrastructure",
          "weightPct": 7.62
        }
      ],
      "topConstituents": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88,
          "sector": "Industrials",
          "profilePath": ""
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23,
          "sector": "Technology",
          "profilePath": "/startup-nayax"
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1,
          "sector": "Real Estate",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-125",
      "name": "TA-125",
      "taseId": "137",
      "family": "Broad equity",
      "description": "Broad equity view combining the tracked TA-35 and TA-90 research universes. Weights are derived from the two seeded universes rather than fetched live.",
      "expectedConstituentCount": 125,
      "coverage": "derived-tracked-universe",
      "weightSource": "derived",
      "weightCapPct": 5,
      "sourceUrl": "https://market.tase.co.il/en/market_data/index/137/about",
      "methodologyNote": "Use this lens for broad public-market concentration, public/private bridge work, and sector exposure comparisons.",
      "constituentCount": 77,
      "trackedCoveragePct": 61.6,
      "knownWeightTotal": 99.99,
      "sourceTypes": [
        "derived-composite"
      ],
      "top5WeightPct": 23.8,
      "top10WeightPct": 38.35,
      "top20WeightPct": 55.67,
      "hhi": 228,
      "profileLinkCount": 9,
      "dualListedCount": 16,
      "sectors": [
        {
          "label": "Finance",
          "weightPct": 29
        },
        {
          "label": "Technology",
          "weightPct": 21.66
        },
        {
          "label": "Energy",
          "weightPct": 17.14
        },
        {
          "label": "Real Estate",
          "weightPct": 15.38
        },
        {
          "label": "Consumer",
          "weightPct": 5.28
        },
        {
          "label": "Healthcare",
          "weightPct": 4.76
        },
        {
          "label": "Communications",
          "weightPct": 2.88
        },
        {
          "label": "Industrials",
          "weightPct": 2.7
        },
        {
          "label": "Materials",
          "weightPct": 1.19
        }
      ],
      "industries": [
        {
          "label": "Banks",
          "weightPct": 16.42
        },
        {
          "label": "Insurance",
          "weightPct": 8.94
        },
        {
          "label": "Income properties",
          "weightPct": 7.88
        },
        {
          "label": "Renewable energy",
          "weightPct": 7.04
        },
        {
          "label": "Defense electronics",
          "weightPct": 4.76
        },
        {
          "label": "Pharmaceuticals",
          "weightPct": 4.76
        },
        {
          "label": "Semiconductors",
          "weightPct": 4.76
        },
        {
          "label": "Semiconductor equipment",
          "weightPct": 4.25
        },
        {
          "label": "Oil and gas exploration",
          "weightPct": 3.28
        },
        {
          "label": "Telecommunications",
          "weightPct": 2.88
        },
        {
          "label": "Food retail",
          "weightPct": 2.15
        },
        {
          "label": "IT services",
          "weightPct": 2.06
        }
      ],
      "themes": [
        {
          "label": "Critical services",
          "weightPct": 31.98
        },
        {
          "label": "Financial system",
          "weightPct": 29
        },
        {
          "label": "Infrastructure",
          "weightPct": 24.48
        },
        {
          "label": "Energy",
          "weightPct": 17.14
        },
        {
          "label": "Technology",
          "weightPct": 16.9
        },
        {
          "label": "Banks",
          "weightPct": 16.42
        },
        {
          "label": "Real estate",
          "weightPct": 15.14
        },
        {
          "label": "Semiconductors",
          "weightPct": 9.51
        },
        {
          "label": "Insurance",
          "weightPct": 8.94
        },
        {
          "label": "Renewables",
          "weightPct": 8.3
        },
        {
          "label": "Industrial inputs",
          "weightPct": 8.26
        },
        {
          "label": "Consumer",
          "weightPct": 7.11
        }
      ],
      "topConstituents": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76,
          "sector": "Technology",
          "profilePath": "/startup-elbit-systems"
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76,
          "sector": "Healthcare",
          "profilePath": ""
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76,
          "sector": "Technology",
          "profilePath": "/startup-tower-semiconductor"
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03,
          "sector": "Technology",
          "profilePath": "/startup-nova-ltd"
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-technology",
      "name": "TA-Technology",
      "taseId": "",
      "family": "Sector equity",
      "description": "Technology-sector lens derived from tracked software, cyber, semiconductor, fintech infrastructure, and health-data constituents.",
      "expectedConstituentCount": 0,
      "coverage": "derived-theme",
      "weightSource": "derived",
      "sourceUrl": "https://www.tase.co.il/en/market_data/indices/sector",
      "methodologyNote": "Use this lens to separate broad technology exposure from the narrower cyber, semiconductor, and defense-tech themes.",
      "constituentCount": 18,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 100,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 67.84,
      "top10WeightPct": 87.66,
      "top20WeightPct": 100,
      "hhi": 1259,
      "profileLinkCount": 9,
      "dualListedCount": 10,
      "sectors": [
        {
          "label": "Technology",
          "weightPct": 96.51
        },
        {
          "label": "Finance",
          "weightPct": 3.49
        }
      ],
      "industries": [
        {
          "label": "Defense electronics",
          "weightPct": 21.2
        },
        {
          "label": "Semiconductors",
          "weightPct": 21.2
        },
        {
          "label": "Semiconductor equipment",
          "weightPct": 18.93
        },
        {
          "label": "IT services",
          "weightPct": 9.21
        },
        {
          "label": "Defense electro-optics",
          "weightPct": 6.51
        },
        {
          "label": "Payments infrastructure",
          "weightPct": 4.6
        },
        {
          "label": "Enterprise software",
          "weightPct": 4.54
        },
        {
          "label": "IT holding company",
          "weightPct": 3.13
        },
        {
          "label": "Payroll and IT services",
          "weightPct": 2.95
        },
        {
          "label": "Payments and credit cards",
          "weightPct": 2.39
        },
        {
          "label": "Semiconductor holding company",
          "weightPct": 2.21
        },
        {
          "label": "Consumer credit",
          "weightPct": 1.1
        }
      ],
      "themes": [
        {
          "label": "Technology",
          "weightPct": 75.31
        },
        {
          "label": "Semiconductors",
          "weightPct": 42.34
        },
        {
          "label": "Defense",
          "weightPct": 27.71
        },
        {
          "label": "Defense resilience",
          "weightPct": 27.71
        },
        {
          "label": "Electronics",
          "weightPct": 27.71
        },
        {
          "label": "Aerospace",
          "weightPct": 21.2
        },
        {
          "label": "Critical materials",
          "weightPct": 21.2
        },
        {
          "label": "Software",
          "weightPct": 20.75
        },
        {
          "label": "Industrial inputs",
          "weightPct": 18.93
        },
        {
          "label": "Critical services",
          "weightPct": 15.28
        },
        {
          "label": "Fintech",
          "weightPct": 8.09
        },
        {
          "label": "AI and data",
          "weightPct": 4.54
        }
      ],
      "topConstituents": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2,
          "sector": "Technology",
          "profilePath": "/startup-elbit-systems"
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2,
          "sector": "Technology",
          "profilePath": "/startup-tower-semiconductor"
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48,
          "sector": "Technology",
          "profilePath": "/startup-nova-ltd"
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51,
          "sector": "Technology",
          "profilePath": "/startup-nextvision-stabilized-systems"
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45,
          "sector": "Technology",
          "profilePath": "/startup-camtek"
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6,
          "sector": "Technology",
          "profilePath": "/startup-nayax"
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95,
          "sector": "Technology",
          "profilePath": ""
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-banks",
      "name": "TA-Banks",
      "taseId": "",
      "family": "Sector equity",
      "description": "Commercial-bank lens derived from tracked banking constituents.",
      "expectedConstituentCount": 0,
      "coverage": "derived-sector",
      "weightSource": "derived",
      "sourceUrl": "https://www.tase.co.il/en/market_data/indices/sector",
      "methodologyNote": "Use this lens to understand how much of the large public-market story is concentrated in bank balance sheets.",
      "constituentCount": 5,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 100.01,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 100.01,
      "top10WeightPct": 100.01,
      "top20WeightPct": 100.01,
      "hhi": 2339,
      "profileLinkCount": 0,
      "dualListedCount": 0,
      "sectors": [
        {
          "label": "Finance",
          "weightPct": 100.01
        }
      ],
      "industries": [
        {
          "label": "Banks",
          "weightPct": 100.01
        }
      ],
      "themes": [
        {
          "label": "Banks",
          "weightPct": 100.01
        },
        {
          "label": "Financial system",
          "weightPct": 100.01
        },
        {
          "label": "Critical services",
          "weightPct": 57.98
        }
      ],
      "topConstituents": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-insurance",
      "name": "TA-Insurance",
      "taseId": "",
      "family": "Sector equity",
      "description": "Insurance and financial-services lens derived from tracked insurers, asset managers, and capital-market platforms.",
      "expectedConstituentCount": 0,
      "coverage": "derived-sector",
      "weightSource": "derived",
      "sourceUrl": "https://www.tase.co.il/en/market_data/indices/sector",
      "methodologyNote": "Use this lens to inspect non-bank finance concentration and domestic savings-system exposure.",
      "constituentCount": 8,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 99.99,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 84.71,
      "top10WeightPct": 99.99,
      "top20WeightPct": 99.99,
      "hhi": 1693,
      "profileLinkCount": 0,
      "dualListedCount": 0,
      "sectors": [
        {
          "label": "Finance",
          "weightPct": 99.99
        }
      ],
      "industries": [
        {
          "label": "Insurance",
          "weightPct": 84.71
        },
        {
          "label": "Capital markets",
          "weightPct": 9.01
        },
        {
          "label": "Asset management",
          "weightPct": 3.92
        },
        {
          "label": "Consumer credit",
          "weightPct": 2.35
        }
      ],
      "themes": [
        {
          "label": "Financial system",
          "weightPct": 99.99
        },
        {
          "label": "Insurance",
          "weightPct": 84.71
        },
        {
          "label": "Market infrastructure",
          "weightPct": 9.01
        },
        {
          "label": "Fintech",
          "weightPct": 2.35
        }
      ],
      "topConstituents": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-real-estate",
      "name": "TA-Real Estate",
      "taseId": "",
      "family": "Sector equity",
      "description": "Real-estate and construction lens derived from tracked property, construction, infrastructure, and development companies.",
      "expectedConstituentCount": 0,
      "coverage": "derived-sector",
      "weightSource": "derived",
      "sourceUrl": "https://www.tase.co.il/en/market_data/indices/sector",
      "methodologyNote": "Use this lens to inspect local property-cycle exposure, infrastructure operators, and construction capacity.",
      "constituentCount": 18,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 100.01,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 45.96,
      "top10WeightPct": 74.38,
      "top20WeightPct": 100.01,
      "hhi": 793,
      "profileLinkCount": 0,
      "dualListedCount": 0,
      "sectors": [
        {
          "label": "Real Estate",
          "weightPct": 88.39
        },
        {
          "label": "Industrials",
          "weightPct": 7.13
        },
        {
          "label": "Consumer",
          "weightPct": 4.49
        }
      ],
      "industries": [
        {
          "label": "Income properties",
          "weightPct": 45.3
        },
        {
          "label": "Retail and mixed-use properties",
          "weightPct": 7.42
        },
        {
          "label": "Infrastructure and contracting",
          "weightPct": 7.13
        },
        {
          "label": "Retail properties",
          "weightPct": 6.25
        },
        {
          "label": "Infrastructure and construction",
          "weightPct": 5.86
        },
        {
          "label": "Construction and real estate",
          "weightPct": 5.7
        },
        {
          "label": "Development and income properties",
          "weightPct": 4.99
        },
        {
          "label": "REIT",
          "weightPct": 4.99
        },
        {
          "label": "Business parks and income properties",
          "weightPct": 4.75
        },
        {
          "label": "Hotels and hospitality",
          "weightPct": 4.49
        },
        {
          "label": "Residential construction",
          "weightPct": 3.13
        }
      ],
      "themes": [
        {
          "label": "Real estate",
          "weightPct": 87.02
        },
        {
          "label": "Infrastructure",
          "weightPct": 60.9
        },
        {
          "label": "Construction",
          "weightPct": 26.81
        },
        {
          "label": "Consumer infrastructure",
          "weightPct": 13.67
        },
        {
          "label": "Critical services",
          "weightPct": 12.99
        },
        {
          "label": "Consumer",
          "weightPct": 4.49
        }
      ],
      "topConstituents": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13,
          "sector": "Industrials",
          "profilePath": ""
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49,
          "sector": "Consumer",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "ta-energy",
      "name": "TA-Energy and Utilities",
      "taseId": "",
      "family": "Sector equity",
      "description": "Energy, oil and gas, utilities, and renewable-energy lens derived from tracked constituents.",
      "expectedConstituentCount": 0,
      "coverage": "derived-sector",
      "weightSource": "derived",
      "sourceUrl": "https://www.tase.co.il/en/market_data/indices/sector",
      "methodologyNote": "Use this lens to connect listed-market exposure to energy security, grid reliability, and import substitution questions.",
      "constituentCount": 13,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 99.99,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 52.91,
      "top10WeightPct": 85.95,
      "top20WeightPct": 99.99,
      "hhi": 864,
      "profileLinkCount": 0,
      "dualListedCount": 4,
      "sectors": [
        {
          "label": "Energy",
          "weightPct": 99.99
        }
      ],
      "industries": [
        {
          "label": "Renewable energy",
          "weightPct": 41.07
        },
        {
          "label": "Oil and gas exploration",
          "weightPct": 19.1
        },
        {
          "label": "Power generation",
          "weightPct": 11.5
        },
        {
          "label": "Renewable power",
          "weightPct": 7.34
        },
        {
          "label": "Fuel and retail infrastructure",
          "weightPct": 6.75
        },
        {
          "label": "Energy holding company",
          "weightPct": 5.55
        },
        {
          "label": "Holding company",
          "weightPct": 4.34
        },
        {
          "label": "Refining and petrochemicals",
          "weightPct": 4.34
        }
      ],
      "themes": [
        {
          "label": "Energy",
          "weightPct": 99.99
        },
        {
          "label": "Infrastructure",
          "weightPct": 64.25
        },
        {
          "label": "Renewables",
          "weightPct": 48.41
        },
        {
          "label": "Critical services",
          "weightPct": 31.99
        },
        {
          "label": "Natural gas",
          "weightPct": 24.65
        },
        {
          "label": "Consumer",
          "weightPct": 6.75
        },
        {
          "label": "Industrial inputs",
          "weightPct": 4.34
        }
      ],
      "topConstituents": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34,
          "sector": "Energy",
          "profilePath": ""
        }
      ]
    },
    {
      "id": "defense-watchlist",
      "name": "Defense and Resilience Watchlist",
      "taseId": "",
      "family": "Strategic theme",
      "description": "Claw & Talon strategic lens for public companies with defense, infrastructure, energy, cyber, semiconductor, or essential-services relevance.",
      "expectedConstituentCount": 0,
      "coverage": "derived-theme",
      "weightSource": "derived",
      "sourceUrl": "https://market.tase.co.il/en/market_data/index/142/about",
      "methodologyNote": "This is not an official TASE index. It is a research watchlist that makes strategic public-market exposure easier to inspect.",
      "constituentCount": 46,
      "trackedCoveragePct": 100,
      "knownWeightTotal": 100.03,
      "sourceTypes": [
        "derived-filtered"
      ],
      "top5WeightPct": 34.1,
      "top10WeightPct": 51.78,
      "top20WeightPct": 70.72,
      "hhi": 372,
      "profileLinkCount": 8,
      "dualListedCount": 13,
      "sectors": [
        {
          "label": "Technology",
          "weightPct": 26.8
        },
        {
          "label": "Energy",
          "weightPct": 24.59
        },
        {
          "label": "Finance",
          "weightPct": 16.54
        },
        {
          "label": "Real Estate",
          "weightPct": 13.41
        },
        {
          "label": "Healthcare",
          "weightPct": 6.82
        },
        {
          "label": "Consumer",
          "weightPct": 4.26
        },
        {
          "label": "Communications",
          "weightPct": 4.13
        },
        {
          "label": "Industrials",
          "weightPct": 1.78
        },
        {
          "label": "Materials",
          "weightPct": 1.7
        }
      ],
      "industries": [
        {
          "label": "Banks",
          "weightPct": 13.64
        },
        {
          "label": "Renewable energy",
          "weightPct": 10.1
        },
        {
          "label": "Income properties",
          "weightPct": 9.35
        },
        {
          "label": "Defense electronics",
          "weightPct": 6.82
        },
        {
          "label": "Pharmaceuticals",
          "weightPct": 6.82
        },
        {
          "label": "Semiconductors",
          "weightPct": 6.82
        },
        {
          "label": "Semiconductor equipment",
          "weightPct": 6.09
        },
        {
          "label": "Oil and gas exploration",
          "weightPct": 4.7
        },
        {
          "label": "Telecommunications",
          "weightPct": 4.13
        },
        {
          "label": "Food retail",
          "weightPct": 3.09
        },
        {
          "label": "Power generation",
          "weightPct": 2.83
        },
        {
          "label": "Market infrastructure",
          "weightPct": 2.13
        }
      ],
      "themes": [
        {
          "label": "Critical services",
          "weightPct": 45.84
        },
        {
          "label": "Infrastructure",
          "weightPct": 35.12
        },
        {
          "label": "Energy",
          "weightPct": 24.59
        },
        {
          "label": "Technology",
          "weightPct": 19.98
        },
        {
          "label": "Financial system",
          "weightPct": 16.54
        },
        {
          "label": "Banks",
          "weightPct": 13.64
        },
        {
          "label": "Semiconductors",
          "weightPct": 13.62
        },
        {
          "label": "Real estate",
          "weightPct": 11.95
        },
        {
          "label": "Renewables",
          "weightPct": 11.9
        },
        {
          "label": "Defense",
          "weightPct": 8.91
        },
        {
          "label": "Defense resilience",
          "weightPct": 8.91
        },
        {
          "label": "Electronics",
          "weightPct": 8.91
        }
      ],
      "topConstituents": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82,
          "sector": "Finance",
          "profilePath": ""
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82,
          "sector": "Technology",
          "profilePath": "/startup-elbit-systems"
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82,
          "sector": "Healthcare",
          "profilePath": ""
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82,
          "sector": "Technology",
          "profilePath": "/startup-tower-semiconductor"
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68,
          "sector": "Real Estate",
          "profilePath": ""
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34,
          "sector": "Technology",
          "profilePath": "/startup-nova-ltd"
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55,
          "sector": "Energy",
          "profilePath": ""
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13,
          "sector": "Finance",
          "profilePath": ""
        }
      ]
    }
  ],
  "constituents": [
    {
      "id": "teva",
      "name": "Teva Pharmaceutical Industries",
      "ticker": "TEVA",
      "isin": "IL0006290147",
      "sector": "Healthcare",
      "industry": "Pharmaceuticals",
      "marketRole": "Global generic and specialty pharmaceuticals company",
      "strategicThemes": [
        "critical-services",
        "essential-medicine",
        "health"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "essential-medicine",
          "label": "Essential medicine"
        },
        {
          "id": "health",
          "label": "Health"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 6.82,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 4.76,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 7,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "eslt",
      "name": "Elbit Systems",
      "ticker": "ESLT",
      "isin": "IL0010811243",
      "sector": "Technology",
      "industry": "Defense electronics",
      "marketRole": "Defense prime and dual-listed systems company",
      "strategicThemes": [
        "aerospace",
        "defense",
        "defense-resilience",
        "electronics"
      ],
      "strategicThemeLabels": [
        {
          "id": "aerospace",
          "label": "Aerospace"
        },
        {
          "id": "defense",
          "label": "Defense"
        },
        {
          "id": "defense-resilience",
          "label": "Defense resilience"
        },
        {
          "id": "electronics",
          "label": "Electronics"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 6.82,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 4.76,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 7,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 21.2,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "elbit-systems",
      "profilePath": "/startup-elbit-systems",
      "profileName": "Elbit Systems"
    },
    {
      "id": "lumi",
      "name": "Bank Leumi Le-Israel",
      "ticker": "LUMI",
      "isin": "IL0006046119",
      "sector": "Finance",
      "industry": "Banks",
      "marketRole": "Large domestic commercial bank",
      "strategicThemes": [
        "banks",
        "critical-services",
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "banks",
          "label": "Banks"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 6.82,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 4.76,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 7,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-banks",
          "weightPct": 28.99,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "poli",
      "name": "Bank Hapoalim",
      "ticker": "POLI",
      "isin": "IL0006625771",
      "sector": "Finance",
      "industry": "Banks",
      "marketRole": "Large domestic commercial bank",
      "strategicThemes": [
        "banks",
        "critical-services",
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "banks",
          "label": "Banks"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 6.82,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 4.76,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 7,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-banks",
          "weightPct": 28.99,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "tsem",
      "name": "Tower Semiconductor",
      "ticker": "TSEM",
      "isin": "IL0010823792",
      "sector": "Technology",
      "industry": "Semiconductors",
      "marketRole": "Specialty foundry and semiconductor manufacturing company",
      "strategicThemes": [
        "critical-materials",
        "semiconductors",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-materials",
          "label": "Critical materials"
        },
        {
          "id": "semiconductors",
          "label": "Semiconductors"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 6.82,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 4.76,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 7,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 21.2,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "tower-semiconductor",
      "profilePath": "/startup-tower-semiconductor",
      "profileName": "Tower Semiconductor"
    },
    {
      "id": "azrg",
      "name": "Azrieli Group",
      "ticker": "AZRG",
      "isin": "IL0011194789",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Large domestic income-property owner and developer",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 4.68,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 3.26,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 4.8,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 18.75,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mztf",
      "name": "Mizrahi Tefahot Bank",
      "ticker": "MZTF",
      "isin": "IL0006954379",
      "sector": "Finance",
      "industry": "Banks",
      "marketRole": "Large domestic commercial and mortgage bank",
      "strategicThemes": [
        "banks",
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "banks",
          "label": "Banks"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 3.26,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 4.8,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-banks",
          "weightPct": 19.88,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nvmi",
      "name": "Nova",
      "ticker": "NVMI",
      "isin": "IL0010845571",
      "sector": "Technology",
      "industry": "Semiconductor equipment",
      "marketRole": "Metrology and process-control equipment supplier",
      "strategicThemes": [
        "industrial-inputs",
        "semiconductors",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        },
        {
          "id": "semiconductors",
          "label": "Semiconductors"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 4.34,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 3.03,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 4.45,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 13.48,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "nova-ltd",
      "profilePath": "/startup-nova-ltd",
      "profileName": "Nova Ltd."
    },
    {
      "id": "phoe",
      "name": "Phoenix Financial",
      "ticker": "PHOE",
      "isin": "IL0007670123",
      "sector": "Finance",
      "industry": "Insurance",
      "marketRole": "Large insurer and institutional capital platform",
      "strategicThemes": [
        "financial-system",
        "insurance"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "insurance",
          "label": "Insurance"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 2.69,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 3.95,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 25.45,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "dsct",
      "name": "Israel Discount Bank",
      "ticker": "DSCT",
      "isin": "IL0006912120",
      "sector": "Finance",
      "industry": "Banks",
      "marketRole": "Domestic commercial bank",
      "strategicThemes": [
        "banks",
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "banks",
          "label": "Banks"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 2.31,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 3.4,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-banks",
          "weightPct": 14.08,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "enlt",
      "name": "Enlight Renewable Energy",
      "ticker": "ENLT",
      "isin": "IL0007200111",
      "sector": "Energy",
      "industry": "Renewable energy",
      "marketRole": "Renewable-energy developer and operator",
      "strategicThemes": [
        "energy",
        "infrastructure",
        "renewables"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "renewables",
          "label": "Renewables"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 3.22,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 2.24,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 3.3,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 13.09,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "harl",
      "name": "Harel Insurance Investments",
      "ticker": "HARL",
      "isin": "IL0005850180",
      "sector": "Finance",
      "industry": "Insurance",
      "marketRole": "Insurer and long-term savings platform",
      "strategicThemes": [
        "financial-system",
        "insurance"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "insurance",
          "label": "Insurance"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 2.14,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 3.15,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 20.29,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "opce",
      "name": "OPC Energy",
      "ticker": "OPCE",
      "isin": "IL0011415713",
      "sector": "Energy",
      "industry": "Power generation",
      "marketRole": "Electricity generation and energy infrastructure company",
      "strategicThemes": [
        "critical-services",
        "energy",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 2.83,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.97,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 2.9,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 11.5,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mmhd",
      "name": "Menora Mivtachim Holdings",
      "ticker": "MMHD",
      "isin": "IL0005660183",
      "sector": "Finance",
      "industry": "Insurance",
      "marketRole": "Insurance and long-term savings platform",
      "strategicThemes": [
        "financial-system",
        "insurance"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "insurance",
          "label": "Insurance"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.8,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 2.65,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 17.07,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nxsn",
      "name": "NextVision Stabilized Systems",
      "ticker": "NXSN",
      "isin": "IL0011765935",
      "sector": "Technology",
      "industry": "Defense electro-optics",
      "marketRole": "Stabilized day and night camera systems for drones and defense platforms",
      "strategicThemes": [
        "defense",
        "defense-resilience",
        "electronics",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "defense",
          "label": "Defense"
        },
        {
          "id": "defense-resilience",
          "label": "Defense resilience"
        },
        {
          "id": "electronics",
          "label": "Electronics"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 2.09,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.46,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 2.15,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 6.51,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "nextvision-stabilized-systems",
      "profilePath": "/startup-nextvision-stabilized-systems",
      "profileName": "NextVision Stabilized Systems"
    },
    {
      "id": "fibi",
      "name": "First International Bank of Israel",
      "ticker": "FIBI",
      "isin": "IL0005930388",
      "sector": "Finance",
      "industry": "Banks",
      "marketRole": "Domestic commercial bank",
      "strategicThemes": [
        "banks",
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "banks",
          "label": "Banks"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.33,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.95,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-banks",
          "weightPct": 8.07,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mlsr",
      "name": "Melisron",
      "ticker": "MLSR",
      "isin": "IL0003230146",
      "sector": "Real Estate",
      "industry": "Retail and mixed-use properties",
      "marketRole": "Shopping-center and income-property company",
      "strategicThemes": [
        "consumer-infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer-infrastructure",
          "label": "Consumer infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.29,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.9,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 7.42,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ora",
      "name": "Ormat Technologies",
      "ticker": "ORA",
      "isin": "US6866881021",
      "sector": "Energy",
      "industry": "Renewable power",
      "marketRole": "Geothermal and renewable-energy company",
      "strategicThemes": [
        "energy",
        "infrastructure",
        "renewables"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "renewables",
          "label": "Renewables"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.8,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.26,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.85,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 7.34,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "camt",
      "name": "Camtek",
      "ticker": "CAMT",
      "isin": "IL0010952641",
      "sector": "Technology",
      "industry": "Semiconductor equipment",
      "marketRole": "Inspection and metrology equipment supplier",
      "strategicThemes": [
        "industrial-inputs",
        "semiconductors",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        },
        {
          "id": "semiconductors",
          "label": "Semiconductors"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.75,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.22,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.8,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 5.45,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "camtek",
      "profilePath": "/startup-camtek",
      "profileName": "Camtek"
    },
    {
      "id": "icl",
      "name": "ICL Group",
      "ticker": "ICL",
      "isin": "IL0002810146",
      "sector": "Materials",
      "industry": "Chemicals and fertilizers",
      "marketRole": "Minerals, fertilizers, and specialty chemicals producer",
      "strategicThemes": [
        "critical-materials",
        "food-security",
        "industrial-inputs"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-materials",
          "label": "Critical materials"
        },
        {
          "id": "food-security",
          "label": "Food security"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.7,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.19,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.75,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "clis",
      "name": "Clal Insurance Enterprises",
      "ticker": "CLIS",
      "isin": "IL0002240146",
      "sector": "Finance",
      "industry": "Insurance",
      "marketRole": "Insurance and institutional capital platform",
      "strategicThemes": [
        "financial-system",
        "insurance"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "insurance",
          "label": "Insurance"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.19,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.75,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 11.27,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "bezq",
      "name": "Bezeq",
      "ticker": "BEZQ",
      "isin": "IL0002300114",
      "sector": "Communications",
      "industry": "Telecommunications",
      "marketRole": "Fixed-line, broadband, and communications infrastructure provider",
      "strategicThemes": [
        "communications",
        "critical-services",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "communications",
          "label": "Communications"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.7,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.19,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.75,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nwmd",
      "name": "NewMed Energy",
      "ticker": "NWMD",
      "isin": "IL0011123830",
      "sector": "Energy",
      "industry": "Oil and gas exploration",
      "marketRole": "Offshore natural-gas partnership",
      "strategicThemes": [
        "critical-services",
        "energy",
        "gas"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "gas",
          "label": "Natural gas"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.66,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.16,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.7,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 6.74,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mgdl",
      "name": "Migdal Insurance and Financial Holdings",
      "ticker": "MGDL",
      "isin": "IL0010811656",
      "sector": "Finance",
      "industry": "Insurance",
      "marketRole": "Insurance, pension, and long-term savings group",
      "strategicThemes": [
        "financial-system",
        "insurance"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "insurance",
          "label": "Insurance"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.12,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.65,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 10.63,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "big",
      "name": "Big Shopping Centers",
      "ticker": "BIG",
      "isin": "IL0010970054",
      "sector": "Real Estate",
      "industry": "Retail properties",
      "marketRole": "Retail-center and income-property operator",
      "strategicThemes": [
        "consumer-infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer-infrastructure",
          "label": "Consumer infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.09,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.6,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 6.25,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nice",
      "name": "NICE",
      "ticker": "NICE",
      "isin": "IL0002730112",
      "sector": "Technology",
      "industry": "Enterprise software",
      "marketRole": "Dual-listed enterprise software and analytics platform",
      "strategicThemes": [
        "ai-data",
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "ai-data",
          "label": "AI and data"
        },
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.02,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.5,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 4.54,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "spen",
      "name": "Shapir Engineering",
      "ticker": "SPEN",
      "isin": "IL0011338758",
      "sector": "Real Estate",
      "industry": "Infrastructure and construction",
      "marketRole": "Infrastructure, construction, and concessions company",
      "strategicThemes": [
        "construction",
        "critical-services",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "construction",
          "label": "Construction"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.46,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.02,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.5,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 5.86,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "dlekg",
      "name": "Delek Group",
      "ticker": "DLEKG",
      "isin": "IL0010841281",
      "sector": "Energy",
      "industry": "Energy holding company",
      "marketRole": "Energy holding company with upstream oil and gas exposure and control of Isracard",
      "strategicThemes": [
        "energy",
        "gas"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "gas",
          "label": "Natural gas"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.36,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.95,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.4,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 5.55,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nvpt",
      "name": "Navitas Petroleum",
      "ticker": "NVPT",
      "isin": "IL0011419699",
      "sector": "Energy",
      "industry": "Oil and gas exploration",
      "marketRole": "Oil and gas exploration and production partnership with Gulf of Mexico and Falkland Islands assets",
      "strategicThemes": [
        "energy",
        "gas"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "gas",
          "label": "Natural gas"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.32,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.92,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.35,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 5.36,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "strs",
      "name": "Strauss Group",
      "ticker": "STRS",
      "isin": "IL0007460160",
      "sector": "Consumer",
      "industry": "Food manufacturing",
      "marketRole": "Food and beverage manufacturer",
      "strategicThemes": [
        "consumer",
        "food-security"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "food-security",
          "label": "Food security"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.17,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.82,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.2,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ftal",
      "name": "Fattal Holdings",
      "ticker": "FTAL",
      "isin": "IL0011434292",
      "sector": "Consumer",
      "industry": "Hotels and hospitality",
      "marketRole": "Hotel and hospitality operator",
      "strategicThemes": [
        "consumer",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.78,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.15,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 4.49,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "sae",
      "name": "Shufersal",
      "ticker": "SAE",
      "isin": "IL0007770378",
      "sector": "Consumer",
      "industry": "Food retail",
      "marketRole": "Large food and grocery retailer",
      "strategicThemes": [
        "consumer",
        "critical-services",
        "food-security"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "food-security",
          "label": "Food security"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.07,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.75,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 1.1,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mvne",
      "name": "Mivne Real Estate",
      "ticker": "MVNE",
      "isin": "IL0002260193",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Industrial, logistics, and income-property company",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.88,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.61,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 0.9,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 3.52,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "amot",
      "name": "Amot Investments",
      "ticker": "AMOT",
      "isin": "IL0010972787",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Office, logistics, and income-property platform",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.83,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.58,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 0.85,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 3.32,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "dimri",
      "name": "Y.H. Dimri Construction and Development",
      "ticker": "DIMRI",
      "isin": "IL0010903156",
      "sector": "Real Estate",
      "industry": "Residential construction",
      "marketRole": "Residential developer and construction company",
      "strategicThemes": [
        "construction",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "construction",
          "label": "Construction"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.54,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-35",
          "weightPct": 0.8,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 3.13,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "dorl",
      "name": "Doral Group",
      "ticker": "DORL",
      "isin": "IL0011689135",
      "sector": "Energy",
      "industry": "Renewable energy",
      "marketRole": "Renewable-energy developer",
      "strategicThemes": [
        "energy",
        "infrastructure",
        "renewables"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "renewables",
          "label": "Renewables"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 2.61,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.82,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 5.68,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 10.61,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "enrg",
      "name": "Energix",
      "ticker": "ENRG",
      "isin": "IL0011236600",
      "sector": "Energy",
      "industry": "Renewable energy",
      "marketRole": "Renewable-energy operator",
      "strategicThemes": [
        "energy",
        "infrastructure",
        "renewables"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "renewables",
          "label": "Renewables"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 2.55,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.78,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 5.56,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 10.37,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "tase",
      "name": "TASE",
      "ticker": "TASE",
      "isin": "IL0011590291",
      "sector": "Finance",
      "industry": "Market infrastructure",
      "marketRole": "Tel Aviv Stock Exchange market-infrastructure operator",
      "strategicThemes": [
        "critical-services",
        "financial-system",
        "market-infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "market-infrastructure",
          "label": "Market infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 2.13,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.49,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 4.65,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "eltr",
      "name": "Electra",
      "ticker": "ELTR",
      "isin": "IL0007390378",
      "sector": "Industrials",
      "industry": "Infrastructure and contracting",
      "marketRole": "Infrastructure, contracting, and services company",
      "strategicThemes": [
        "construction",
        "critical-services",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "construction",
          "label": "Construction"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.78,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.24,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.88,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 7.13,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nofr",
      "name": "Nofar Energy",
      "ticker": "NOFR",
      "isin": "IL0011718751",
      "sector": "Energy",
      "industry": "Renewable energy",
      "marketRole": "Renewable-energy developer",
      "strategicThemes": [
        "energy",
        "infrastructure",
        "renewables"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "renewables",
          "label": "Renewables"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.72,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.2,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.75,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 7,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "enog",
      "name": "Energean",
      "ticker": "ENOG",
      "isin": "GB00BG12Y042",
      "sector": "Energy",
      "industry": "Oil and gas exploration",
      "marketRole": "Eastern Mediterranean gas producer",
      "strategicThemes": [
        "critical-services",
        "energy",
        "gas"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "gas",
          "label": "Natural gas"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.72,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.2,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.75,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 7,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "paz",
      "name": "Paz Retail and Energy",
      "ticker": "PAZ",
      "isin": "IL0011000077",
      "sector": "Energy",
      "industry": "Fuel and retail infrastructure",
      "marketRole": "Fuel distribution, retail, and energy infrastructure company",
      "strategicThemes": [
        "consumer",
        "critical-services",
        "energy"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "energy",
          "label": "Energy"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.66,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.16,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.62,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 6.75,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "afpr",
      "name": "AFI Properties",
      "ticker": "AFPR",
      "isin": "IL0010947625",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Income-property and development company",
      "strategicThemes": [
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 1.12,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.49,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 6.41,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "gvym",
      "name": "Bayside Land Corporation (Gav-Yam)",
      "ticker": "GVYM",
      "isin": "IL0007590191",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Income-property and development company",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.54,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.07,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.36,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 6.17,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mtrx",
      "name": "Matrix IT",
      "ticker": "MTRX",
      "isin": "IL0004450158",
      "sector": "Technology",
      "industry": "IT services",
      "marketRole": "Enterprise IT services and systems-integration group that absorbed Magic Software in 2026",
      "strategicThemes": [
        "critical-services",
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.48,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.03,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.23,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 4.6,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "nyax",
      "name": "Nayax",
      "ticker": "NYAX",
      "isin": "IL0011754137",
      "sector": "Technology",
      "industry": "Payments infrastructure",
      "marketRole": "Payments and unattended-retail platform",
      "strategicThemes": [
        "critical-services",
        "fintech",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "fintech",
          "label": "Fintech"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.48,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 1.03,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.23,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 4.6,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "nayax",
      "profilePath": "/startup-nayax",
      "profileName": "Nayax"
    },
    {
      "id": "alhe",
      "name": "Alony Hetz",
      "ticker": "ALHE",
      "isin": "IL0003900136",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "Income-property investment company",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.42,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.99,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.1,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 5.7,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ashg",
      "name": "Ashtrom Group",
      "ticker": "ASHG",
      "isin": "IL0011320343",
      "sector": "Real Estate",
      "industry": "Construction and real estate",
      "marketRole": "Construction, infrastructure, and real-estate group",
      "strategicThemes": [
        "construction",
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "construction",
          "label": "Construction"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.42,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.99,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 3.1,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 5.7,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ptnr",
      "name": "Partner Communications",
      "ticker": "PTNR",
      "isin": "IL0010834849",
      "sector": "Communications",
      "industry": "Telecommunications",
      "marketRole": "Mobile and fixed communications provider",
      "strategicThemes": [
        "communications",
        "critical-services",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "communications",
          "label": "Communications"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.36,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.95,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.97,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ibi",
      "name": "IBI Investment House",
      "ticker": "IBI",
      "isin": "IL0001750186",
      "sector": "Finance",
      "industry": "Capital markets",
      "marketRole": "Investment house and capital-market services platform",
      "strategicThemes": [
        "financial-system",
        "market-infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "market-infrastructure",
          "label": "Market infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.95,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.97,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 9.01,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "iscn",
      "name": "Israel Canada",
      "ticker": "ISCN",
      "isin": "IL0010897887",
      "sector": "Real Estate",
      "industry": "Development and income properties",
      "marketRole": "Real-estate development company",
      "strategicThemes": [
        "construction",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "construction",
          "label": "Construction"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.87,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.71,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 4.99,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "arpt",
      "name": "Airport City",
      "ticker": "ARPT",
      "isin": "IL0010958358",
      "sector": "Real Estate",
      "industry": "Business parks and income properties",
      "marketRole": "Income-property and business-park company",
      "strategicThemes": [
        "infrastructure",
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        },
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.18,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.83,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.58,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 4.75,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ilco",
      "name": "Israel Corporation",
      "ticker": "ILCO",
      "isin": "IL0005760173",
      "sector": "Industrials",
      "industry": "Holding company",
      "marketRole": "Industrial holding company with materials and infrastructure exposure",
      "strategicThemes": [
        "critical-materials",
        "industrial-inputs"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-materials",
          "label": "Critical materials"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.79,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.45,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "orl",
      "name": "Bazan",
      "ticker": "ORL",
      "isin": "IL0002590248",
      "sector": "Energy",
      "industry": "Refining and petrochemicals",
      "marketRole": "Refining and petrochemicals company",
      "strategicThemes": [
        "energy",
        "industrial-inputs"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.07,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.74,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.33,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 4.34,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "cel",
      "name": "Cellcom Israel",
      "ticker": "CEL",
      "isin": "IL0011015349",
      "sector": "Communications",
      "industry": "Telecommunications",
      "marketRole": "Mobile and fixed communications provider",
      "strategicThemes": [
        "communications",
        "critical-services",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "communications",
          "label": "Communications"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.07,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.74,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.33,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "ken",
      "name": "Kenon Holdings",
      "ticker": "KEN",
      "isin": "SG9999012629",
      "sector": "Energy",
      "industry": "Holding company",
      "marketRole": "Holding company with energy and infrastructure exposure",
      "strategicThemes": [
        "energy",
        "infrastructure"
      ],
      "strategicThemeLabels": [
        {
          "id": "energy",
          "label": "Energy"
        },
        {
          "id": "infrastructure",
          "label": "Infrastructure"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.07,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.74,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.33,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-energy",
          "weightPct": 4.34,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "forty",
      "name": "Formula Systems",
      "ticker": "FORTY",
      "isin": "IL0002560162",
      "sector": "Technology",
      "industry": "IT holding company",
      "marketRole": "Dual-listed IT services and software holding company",
      "strategicThemes": [
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.7,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.2,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 3.13,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "yhnf",
      "name": "Yochananof",
      "ticker": "YHNF",
      "isin": "IL0011609851",
      "sector": "Consumer",
      "industry": "Food retail",
      "marketRole": "Food retail operator",
      "strategicThemes": [
        "consumer",
        "critical-services",
        "food-security"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "food-security",
          "label": "Food security"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.01,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.7,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.2,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "rmli",
      "name": "Rami Levy",
      "ticker": "RMLI",
      "isin": "IL0011042492",
      "sector": "Consumer",
      "industry": "Food retail",
      "marketRole": "Food retail and discount grocery operator",
      "strategicThemes": [
        "consumer",
        "critical-services",
        "food-security"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "food-security",
          "label": "Food security"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 1.01,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.7,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.2,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "hlan",
      "name": "Hilan",
      "ticker": "HLAN",
      "isin": "IL0010849870",
      "sector": "Technology",
      "industry": "Payroll and IT services",
      "marketRole": "Payroll, human-capital, and IT services company",
      "strategicThemes": [
        "critical-services",
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.95,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.66,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.07,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 2.95,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "one",
      "name": "One Software Technologies",
      "ticker": "ONE",
      "isin": "IL0001610182",
      "sector": "Technology",
      "industry": "IT services",
      "marketRole": "Enterprise IT services and systems integration company",
      "strategicThemes": [
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.66,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 2.07,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 2.95,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "rit1",
      "name": "REIT 1",
      "ticker": "RIT1",
      "isin": "IL0010989203",
      "sector": "Real Estate",
      "industry": "REIT",
      "marketRole": "Real-estate investment trust",
      "strategicThemes": [
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.62,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.94,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 3.56,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "delg",
      "name": "Delta Galil",
      "ticker": "DELG",
      "isin": "IL0006270347",
      "sector": "Consumer",
      "industry": "Apparel manufacturing",
      "marketRole": "Textile and apparel manufacturer",
      "strategicThemes": [
        "consumer",
        "industrial-inputs"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.62,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.94,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "fox",
      "name": "Fox Wizel",
      "ticker": "FOX",
      "isin": "IL0010878242",
      "sector": "Consumer",
      "industry": "Retail",
      "marketRole": "Retail and brand operator",
      "strategicThemes": [
        "consumer"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.58,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.81,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "iscd",
      "name": "Isracard",
      "ticker": "ISCD",
      "isin": "IL0011574030",
      "sector": "Finance",
      "industry": "Payments and credit cards",
      "marketRole": "Payments and credit-card platform controlled by Delek Group",
      "strategicThemes": [
        "critical-services",
        "financial-system",
        "fintech"
      ],
      "strategicThemeLabels": [
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "fintech",
          "label": "Fintech"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.77,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.54,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.68,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 2.39,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "prtc",
      "name": "Priortech",
      "ticker": "PRTC",
      "isin": "IL0003280133",
      "sector": "Technology",
      "industry": "Semiconductor holding company",
      "marketRole": "Technology holding company with semiconductor exposure",
      "strategicThemes": [
        "semiconductors",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "semiconductors",
          "label": "Semiconductors"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.71,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.5,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.55,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 2.21,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mtrn",
      "name": "Maytronics",
      "ticker": "MTRN",
      "isin": "IL0010910656",
      "sector": "Industrials",
      "industry": "Robotics and consumer equipment",
      "marketRole": "Robotic pool-cleaning systems company",
      "strategicThemes": [
        "consumer",
        "industrial-inputs",
        "robotics"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        },
        {
          "id": "robotics",
          "label": "Robotics"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.5,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.55,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mrin",
      "name": "More Investment House",
      "ticker": "MRIN",
      "isin": "IL0011516577",
      "sector": "Finance",
      "industry": "Asset management",
      "marketRole": "Investment house and asset-management platform",
      "strategicThemes": [
        "financial-system"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.41,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.29,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 3.92,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "mltm",
      "name": "Malam Team",
      "ticker": "MLTM",
      "isin": "IL0001560189",
      "sector": "Technology",
      "industry": "IT services",
      "marketRole": "Enterprise IT services company",
      "strategicThemes": [
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.37,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.16,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 1.66,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "crsm",
      "name": "Carasso Motors",
      "ticker": "CRSM",
      "isin": "IL0011267213",
      "sector": "Consumer",
      "industry": "Automotive distribution",
      "marketRole": "Vehicle importer and mobility services company",
      "strategicThemes": [
        "consumer",
        "mobility"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "mobility",
          "label": "Mobility"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.33,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 1.03,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "slarl",
      "name": "Sella Capital",
      "ticker": "SLARL",
      "isin": "IL0010980780",
      "sector": "Real Estate",
      "industry": "REIT",
      "marketRole": "Real-estate investment trust",
      "strategicThemes": [
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.25,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.78,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 1.43,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "difi",
      "name": "Direct Finance",
      "ticker": "DIFI",
      "isin": "IL0011651820",
      "sector": "Finance",
      "industry": "Consumer credit",
      "marketRole": "Non-bank credit platform",
      "strategicThemes": [
        "financial-system",
        "fintech"
      ],
      "strategicThemeLabels": [
        {
          "id": "financial-system",
          "label": "Financial system"
        },
        {
          "id": "fintech",
          "label": "Fintech"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.25,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.78,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-insurance",
          "weightPct": 2.35,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 1.1,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "gct",
      "name": "G City",
      "ticker": "GCT",
      "isin": "IL0001260111",
      "sector": "Real Estate",
      "industry": "Income properties",
      "marketRole": "International income-property company",
      "strategicThemes": [
        "real-estate"
      ],
      "strategicThemeLabels": [
        {
          "id": "real-estate",
          "label": "Real estate"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.25,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.78,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-real-estate",
          "weightPct": 1.43,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "peri",
      "name": "Perion Network",
      "ticker": "PERI",
      "isin": "IL0010958192",
      "sector": "Technology",
      "industry": "Digital advertising technology",
      "marketRole": "Advertising-technology company",
      "strategicThemes": [
        "software",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "software",
          "label": "Software"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.21,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.65,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 0.92,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "perion-network",
      "profilePath": "/startup-perion-network",
      "profileName": "Perion Network"
    },
    {
      "id": "audc",
      "name": "AudioCodes",
      "ticker": "AUDC",
      "isin": "IL0010829658",
      "sector": "Technology",
      "industry": "Communications software and hardware",
      "marketRole": "Voice, communications, and networking technology company",
      "strategicThemes": [
        "communications",
        "critical-services",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "communications",
          "label": "Communications"
        },
        {
          "id": "critical-services",
          "label": "Critical services"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.24,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.17,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.52,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 0.74,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "audiocodes",
      "profilePath": "/startup-audiocodes",
      "profileName": "AudioCodes"
    },
    {
      "id": "hap",
      "name": "Hadera Paper",
      "ticker": "HAP",
      "isin": "IL0006320183",
      "sector": "Industrials",
      "industry": "Paper and packaging",
      "marketRole": "Packaging and paper-products company",
      "strategicThemes": [
        "consumer",
        "industrial-inputs"
      ],
      "strategicThemeLabels": [
        {
          "id": "consumer",
          "label": "Consumer"
        },
        {
          "id": "industrial-inputs",
          "label": "Industrial inputs"
        }
      ],
      "dualListed": false,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "ta-125",
          "weightPct": 0.17,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.52,
          "source": "curated-normalized"
        }
      ],
      "profileSlug": "",
      "profilePath": "",
      "profileName": ""
    },
    {
      "id": "bvc",
      "name": "BATM Advanced Communications",
      "ticker": "BVC",
      "isin": "IL0010849045",
      "sector": "Technology",
      "industry": "Communications and medical systems",
      "marketRole": "Communications and medical-technology group",
      "strategicThemes": [
        "communications",
        "health",
        "technology"
      ],
      "strategicThemeLabels": [
        {
          "id": "communications",
          "label": "Communications"
        },
        {
          "id": "health",
          "label": "Health"
        },
        {
          "id": "technology",
          "label": "Technology"
        }
      ],
      "dualListed": true,
      "sourceUrls": [],
      "memberships": [
        {
          "indexId": "defense-watchlist",
          "weightPct": 0.12,
          "source": "derived-filtered"
        },
        {
          "indexId": "ta-125",
          "weightPct": 0.08,
          "source": "derived-composite"
        },
        {
          "indexId": "ta-90",
          "weightPct": 0.26,
          "source": "curated-normalized"
        },
        {
          "indexId": "ta-technology",
          "weightPct": 0.37,
          "source": "derived-filtered"
        }
      ],
      "profileSlug": "batm-advanced",
      "profilePath": "/startup-batm-advanced",
      "profileName": "BATM Advanced Communications"
    }
  ],
  "themes": [
    {
      "id": "aerospace",
      "label": "Aerospace"
    },
    {
      "id": "ai-data",
      "label": "AI and data"
    },
    {
      "id": "banks",
      "label": "Banks"
    },
    {
      "id": "communications",
      "label": "Communications"
    },
    {
      "id": "construction",
      "label": "Construction"
    },
    {
      "id": "consumer",
      "label": "Consumer"
    },
    {
      "id": "consumer-infrastructure",
      "label": "Consumer infrastructure"
    },
    {
      "id": "critical-materials",
      "label": "Critical materials"
    },
    {
      "id": "critical-services",
      "label": "Critical services"
    },
    {
      "id": "defense",
      "label": "Defense"
    },
    {
      "id": "defense-resilience",
      "label": "Defense resilience"
    },
    {
      "id": "electronics",
      "label": "Electronics"
    },
    {
      "id": "energy",
      "label": "Energy"
    },
    {
      "id": "essential-medicine",
      "label": "Essential medicine"
    },
    {
      "id": "financial-system",
      "label": "Financial system"
    },
    {
      "id": "fintech",
      "label": "Fintech"
    },
    {
      "id": "food-security",
      "label": "Food security"
    },
    {
      "id": "gas",
      "label": "Natural gas"
    },
    {
      "id": "health",
      "label": "Health"
    },
    {
      "id": "industrial-inputs",
      "label": "Industrial inputs"
    },
    {
      "id": "infrastructure",
      "label": "Infrastructure"
    },
    {
      "id": "insurance",
      "label": "Insurance"
    },
    {
      "id": "market-infrastructure",
      "label": "Market infrastructure"
    },
    {
      "id": "mobility",
      "label": "Mobility"
    },
    {
      "id": "real-estate",
      "label": "Real estate"
    },
    {
      "id": "renewables",
      "label": "Renewables"
    },
    {
      "id": "robotics",
      "label": "Robotics"
    },
    {
      "id": "semiconductors",
      "label": "Semiconductors"
    },
    {
      "id": "software",
      "label": "Software"
    },
    {
      "id": "technology",
      "label": "Technology"
    }
  ],
  "overlap": [
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-90",
      "sharedCount": 0,
      "leftOnlyCount": 35,
      "rightOnlyCount": 42,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-125",
      "sharedCount": 35,
      "leftOnlyCount": 0,
      "rightOnlyCount": 42,
      "leftSharedWeightPct": 100,
      "rightSharedWeightPct": 67.99,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 7,
          "rightWeightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 7,
          "rightWeightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 7,
          "rightWeightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 7,
          "rightWeightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 7,
          "rightWeightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.8,
          "rightWeightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 4.8,
          "rightWeightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.45,
          "rightWeightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 3.95,
          "rightWeightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 3.4,
          "rightWeightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.3,
          "rightWeightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 3.15,
          "rightWeightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.9,
          "rightWeightPct": 1.97
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 2.65,
          "rightWeightPct": 1.8
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.15,
          "rightWeightPct": 1.46
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 1.95,
          "rightWeightPct": 1.33
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 1.9,
          "rightWeightPct": 1.29
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.85,
          "rightWeightPct": 1.26
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 1.78
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 1.49
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.24
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.2
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 1.2
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 1.16
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 1.12
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 1.07
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 1.03
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 1.03
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 0.99
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-technology",
      "sharedCount": 6,
      "leftOnlyCount": 29,
      "rightOnlyCount": 12,
      "leftSharedWeightPct": 23.9,
      "rightSharedWeightPct": 72.38,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 7,
          "rightWeightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 7,
          "rightWeightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.45,
          "rightWeightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.15,
          "rightWeightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.8,
          "rightWeightPct": 5.45
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "leftWeightPct": 1.5,
          "rightWeightPct": 4.54
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.95
        }
      ],
      "rightOnly": [
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "weightPct": 2.21
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "weightPct": 0.92
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "weightPct": 0.74
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "weightPct": 0.37
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-banks",
      "sharedCount": 5,
      "leftOnlyCount": 30,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 24.15,
      "rightSharedWeightPct": 100.01,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 7,
          "rightWeightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 7,
          "rightWeightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 4.8,
          "rightWeightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 3.4,
          "rightWeightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 1.95,
          "rightWeightPct": 8.07
        }
      ],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.15
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.9
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-insurance",
      "sharedCount": 5,
      "leftOnlyCount": 30,
      "rightOnlyCount": 3,
      "leftSharedWeightPct": 13.15,
      "rightSharedWeightPct": 84.71,
      "shared": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 3.95,
          "rightWeightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 3.15,
          "rightWeightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 2.65,
          "rightWeightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "leftWeightPct": 1.75,
          "rightWeightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "leftWeightPct": 1.65,
          "rightWeightPct": 10.63
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.15
        }
      ],
      "rightOnly": [
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 8,
      "leftOnlyCount": 27,
      "rightOnlyCount": 10,
      "leftSharedWeightPct": 13.5,
      "rightSharedWeightPct": 52.74,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.8,
          "rightWeightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 1.9,
          "rightWeightPct": 7.42
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "leftWeightPct": 1.6,
          "rightWeightPct": 6.25
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 1.5,
          "rightWeightPct": 5.86
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "leftWeightPct": 1.15,
          "rightWeightPct": 4.49
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 0.9,
          "rightWeightPct": 3.52
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 0.85,
          "rightWeightPct": 3.32
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "leftWeightPct": 0.8,
          "rightWeightPct": 3.13
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        }
      ],
      "rightOnly": [
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 3.56
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "weightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "weightPct": 1.43
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "ta-energy",
      "sharedCount": 6,
      "leftOnlyCount": 29,
      "rightOnlyCount": 7,
      "leftSharedWeightPct": 12.5,
      "rightSharedWeightPct": 49.58,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.3,
          "rightWeightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.9,
          "rightWeightPct": 11.5
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.85,
          "rightWeightPct": 7.34
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 1.7,
          "rightWeightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 1.4,
          "rightWeightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 1.35,
          "rightWeightPct": 5.36
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "weightPct": 4.34
        }
      ]
    },
    {
      "leftIndexId": "ta-35",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 22,
      "leftOnlyCount": 13,
      "rightOnlyCount": 24,
      "leftSharedWeightPct": 69.75,
      "rightSharedWeightPct": 67.96,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 7,
          "rightWeightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 7,
          "rightWeightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 7,
          "rightWeightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 7,
          "rightWeightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 7,
          "rightWeightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.8,
          "rightWeightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.45,
          "rightWeightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.3,
          "rightWeightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.9,
          "rightWeightPct": 2.83
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.15,
          "rightWeightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.85,
          "rightWeightPct": 1.8
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.8,
          "rightWeightPct": 1.75
        },
        {
          "id": "bezq",
          "name": "Bezeq",
          "ticker": "BEZQ",
          "leftWeightPct": 1.75,
          "rightWeightPct": 1.7
        },
        {
          "id": "icl",
          "name": "ICL Group",
          "ticker": "ICL",
          "leftWeightPct": 1.75,
          "rightWeightPct": 1.7
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 1.7,
          "rightWeightPct": 1.66
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 1.5,
          "rightWeightPct": 1.46
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 1.4,
          "rightWeightPct": 1.36
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 1.35,
          "rightWeightPct": 1.32
        }
      ],
      "leftOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.95
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.9
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 1.75
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 1.65
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 1.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 1.5
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 1.15
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.72
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 1.72
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 1.66
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 1.54
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 1.48
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 1.48
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 1.42
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 1.42
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-35",
      "sharedCount": 0,
      "leftOnlyCount": 42,
      "rightOnlyCount": 35,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-125",
      "sharedCount": 42,
      "leftOnlyCount": 0,
      "rightOnlyCount": 35,
      "leftSharedWeightPct": 100.05,
      "rightSharedWeightPct": 32,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 5.68,
          "rightWeightPct": 1.82
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 5.56,
          "rightWeightPct": 1.78
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 4.65,
          "rightWeightPct": 1.49
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 3.88,
          "rightWeightPct": 1.24
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 3.75,
          "rightWeightPct": 1.2
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 3.75,
          "rightWeightPct": 1.2
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 3.62,
          "rightWeightPct": 1.16
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 3.49,
          "rightWeightPct": 1.12
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 3.36,
          "rightWeightPct": 1.07
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 1.03
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 1.03
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 3.1,
          "rightWeightPct": 0.99
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 3.1,
          "rightWeightPct": 0.99
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 2.97,
          "rightWeightPct": 0.95
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "leftWeightPct": 2.97,
          "rightWeightPct": 0.95
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 2.71,
          "rightWeightPct": 0.87
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 2.58,
          "rightWeightPct": 0.83
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "leftWeightPct": 2.45,
          "rightWeightPct": 0.79
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-technology",
      "sharedCount": 12,
      "leftOnlyCount": 30,
      "rightOnlyCount": 6,
      "leftSharedWeightPct": 19.4,
      "rightSharedWeightPct": 27.62,
      "shared": [
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 4.6
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "leftWeightPct": 2.2,
          "rightWeightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 2.07,
          "rightWeightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "leftWeightPct": 2.07,
          "rightWeightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 1.68,
          "rightWeightPct": 2.39
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 1.55,
          "rightWeightPct": 2.21
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "leftWeightPct": 1.16,
          "rightWeightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 0.78,
          "rightWeightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "leftWeightPct": 0.65,
          "rightWeightPct": 0.92
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.52,
          "rightWeightPct": 0.74
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.26,
          "rightWeightPct": 0.37
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 3.1
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-banks",
      "sharedCount": 0,
      "leftOnlyCount": 42,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-insurance",
      "sharedCount": 3,
      "leftOnlyCount": 39,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 5.04,
      "rightSharedWeightPct": 15.28,
      "shared": [
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 2.97,
          "rightWeightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "leftWeightPct": 1.29,
          "rightWeightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 0.78,
          "rightWeightPct": 2.35
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 10,
      "leftOnlyCount": 32,
      "rightOnlyCount": 8,
      "leftSharedWeightPct": 25.72,
      "rightSharedWeightPct": 47.27,
      "shared": [
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 3.88,
          "rightWeightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 3.49,
          "rightWeightPct": 6.41
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 3.36,
          "rightWeightPct": 6.17
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 3.1,
          "rightWeightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 3.1,
          "rightWeightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 2.71,
          "rightWeightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 2.58,
          "rightWeightPct": 4.75
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "leftWeightPct": 1.94,
          "rightWeightPct": 3.56
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "leftWeightPct": 0.78,
          "rightWeightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "leftWeightPct": 0.78,
          "rightWeightPct": 1.43
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "weightPct": 2.97
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "weightPct": 2.45
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 2.33
        }
      ],
      "rightOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "weightPct": 3.52
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "weightPct": 3.32
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "weightPct": 3.13
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "ta-energy",
      "sharedCount": 7,
      "leftOnlyCount": 35,
      "rightOnlyCount": 6,
      "leftSharedWeightPct": 27.02,
      "rightSharedWeightPct": 50.41,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 5.68,
          "rightWeightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 5.56,
          "rightWeightPct": 10.37
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 3.75,
          "rightWeightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 3.75,
          "rightWeightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 3.62,
          "rightWeightPct": 6.75
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 2.33,
          "rightWeightPct": 4.34
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 2.33,
          "rightWeightPct": 4.34
        }
      ],
      "leftOnly": [
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 3.1
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "weightPct": 2.97
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 2.71
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 2.58
        }
      ],
      "rightOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        }
      ]
    },
    {
      "leftIndexId": "ta-90",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 24,
      "leftOnlyCount": 18,
      "rightOnlyCount": 22,
      "leftSharedWeightPct": 69.93,
      "rightSharedWeightPct": 32.07,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 5.68,
          "rightWeightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 5.56,
          "rightWeightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 4.65,
          "rightWeightPct": 2.13
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 3.88,
          "rightWeightPct": 1.78
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 3.75,
          "rightWeightPct": 1.72
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 3.75,
          "rightWeightPct": 1.72
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 3.62,
          "rightWeightPct": 1.66
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 3.36,
          "rightWeightPct": 1.54
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 1.48
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 3.23,
          "rightWeightPct": 1.48
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 3.1,
          "rightWeightPct": 1.42
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 3.1,
          "rightWeightPct": 1.42
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "leftWeightPct": 2.97,
          "rightWeightPct": 1.36
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 2.58,
          "rightWeightPct": 1.18
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 2.33,
          "rightWeightPct": 1.07
        },
        {
          "id": "cel",
          "name": "Cellcom Israel",
          "ticker": "CEL",
          "leftWeightPct": 2.33,
          "rightWeightPct": 1.07
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 2.33,
          "rightWeightPct": 1.07
        },
        {
          "id": "rmli",
          "name": "Rami Levy",
          "ticker": "RMLI",
          "leftWeightPct": 2.2,
          "rightWeightPct": 1.01
        }
      ],
      "leftOnly": [
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 2.71
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "weightPct": 2.45
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 2.2
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.07
        },
        {
          "id": "delg",
          "name": "Delta Galil",
          "ticker": "DELG",
          "weightPct": 1.94
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 1.94
        },
        {
          "id": "fox",
          "name": "Fox Wizel",
          "ticker": "FOX",
          "weightPct": 1.81
        },
        {
          "id": "mtrn",
          "name": "Maytronics",
          "ticker": "MTRN",
          "weightPct": 1.55
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 1.29
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.16
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 1.75
        }
      ]
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-35",
      "sharedCount": 35,
      "leftOnlyCount": 42,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 67.99,
      "rightSharedWeightPct": 100,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 4.76,
          "rightWeightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 4.76,
          "rightWeightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 4.76,
          "rightWeightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 3.26,
          "rightWeightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 3.26,
          "rightWeightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 3.03,
          "rightWeightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 2.69,
          "rightWeightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 2.31,
          "rightWeightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 2.24,
          "rightWeightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 2.14,
          "rightWeightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 1.97,
          "rightWeightPct": 2.9
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 1.8,
          "rightWeightPct": 2.65
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 1.46,
          "rightWeightPct": 2.15
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 1.33,
          "rightWeightPct": 1.95
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 1.29,
          "rightWeightPct": 1.9
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.26,
          "rightWeightPct": 1.85
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 1.78
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 1.49
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.24
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.2
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 1.2
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 1.16
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 1.12
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 1.07
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 1.03
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 1.03
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 0.99
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-90",
      "sharedCount": 42,
      "leftOnlyCount": 35,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 32,
      "rightSharedWeightPct": 100.05,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 1.82,
          "rightWeightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 1.78,
          "rightWeightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 1.49,
          "rightWeightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.24,
          "rightWeightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.2,
          "rightWeightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.2,
          "rightWeightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 1.16,
          "rightWeightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 1.12,
          "rightWeightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 1.07,
          "rightWeightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 1.03,
          "rightWeightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 1.03,
          "rightWeightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 0.99,
          "rightWeightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 0.99,
          "rightWeightPct": 3.1
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 0.95,
          "rightWeightPct": 2.97
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "leftWeightPct": 0.95,
          "rightWeightPct": 2.97
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 0.87,
          "rightWeightPct": 2.71
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 0.83,
          "rightWeightPct": 2.58
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "leftWeightPct": 0.79,
          "rightWeightPct": 2.45
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-technology",
      "sharedCount": 18,
      "leftOnlyCount": 59,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 22.45,
      "rightSharedWeightPct": 100,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 4.76,
          "rightWeightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 4.76,
          "rightWeightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 3.03,
          "rightWeightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 1.46,
          "rightWeightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.22,
          "rightWeightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 1.03,
          "rightWeightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 1.03,
          "rightWeightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "leftWeightPct": 1.02,
          "rightWeightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "leftWeightPct": 0.7,
          "rightWeightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 0.66,
          "rightWeightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "leftWeightPct": 0.66,
          "rightWeightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 0.54,
          "rightWeightPct": 2.39
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 0.5,
          "rightWeightPct": 2.21
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "leftWeightPct": 0.37,
          "rightWeightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 0.25,
          "rightWeightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "leftWeightPct": 0.21,
          "rightWeightPct": 0.92
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.17,
          "rightWeightPct": 0.74
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.08,
          "rightWeightPct": 0.37
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-banks",
      "sharedCount": 5,
      "leftOnlyCount": 72,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 16.42,
      "rightSharedWeightPct": 100.01,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 3.26,
          "rightWeightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 2.31,
          "rightWeightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 1.33,
          "rightWeightPct": 8.07
        }
      ],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 1.78
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-insurance",
      "sharedCount": 8,
      "leftOnlyCount": 69,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 10.55,
      "rightSharedWeightPct": 99.99,
      "shared": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 2.69,
          "rightWeightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 2.14,
          "rightWeightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 1.8,
          "rightWeightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "leftWeightPct": 1.19,
          "rightWeightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "leftWeightPct": 1.12,
          "rightWeightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 0.95,
          "rightWeightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "leftWeightPct": 0.41,
          "rightWeightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 0.25,
          "rightWeightPct": 2.35
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 18,
      "leftOnlyCount": 59,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 17.4,
      "rightSharedWeightPct": 100.01,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 3.26,
          "rightWeightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 1.29,
          "rightWeightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.24,
          "rightWeightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 1.12,
          "rightWeightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "leftWeightPct": 1.09,
          "rightWeightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 1.07,
          "rightWeightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 1.02,
          "rightWeightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 0.99,
          "rightWeightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 0.99,
          "rightWeightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 0.87,
          "rightWeightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 0.83,
          "rightWeightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "leftWeightPct": 0.78,
          "rightWeightPct": 4.49
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "leftWeightPct": 0.62,
          "rightWeightPct": 3.56
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 0.61,
          "rightWeightPct": 3.52
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 0.58,
          "rightWeightPct": 3.32
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "leftWeightPct": 0.54,
          "rightWeightPct": 3.13
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "leftWeightPct": 0.25,
          "rightWeightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "leftWeightPct": 0.25,
          "rightWeightPct": 1.43
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "ta-energy",
      "sharedCount": 13,
      "leftOnlyCount": 64,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 17.14,
      "rightSharedWeightPct": 99.99,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 2.24,
          "rightWeightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 1.97,
          "rightWeightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 1.82,
          "rightWeightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 1.78,
          "rightWeightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.26,
          "rightWeightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.2,
          "rightWeightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.2,
          "rightWeightPct": 7
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 1.16,
          "rightWeightPct": 6.74
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 1.16,
          "rightWeightPct": 6.75
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 0.95,
          "rightWeightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 0.92,
          "rightWeightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 0.74,
          "rightWeightPct": 4.34
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 0.74,
          "rightWeightPct": 4.34
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-125",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 46,
      "leftOnlyCount": 31,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 69.78,
      "rightSharedWeightPct": 100.03,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 4.76,
          "rightWeightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 4.76,
          "rightWeightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 4.76,
          "rightWeightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 4.76,
          "rightWeightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 3.26,
          "rightWeightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 3.03,
          "rightWeightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 2.24,
          "rightWeightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 1.97,
          "rightWeightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 1.82,
          "rightWeightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 1.78,
          "rightWeightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 1.49,
          "rightWeightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 1.46,
          "rightWeightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.26,
          "rightWeightPct": 1.8
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.24,
          "rightWeightPct": 1.78
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.22,
          "rightWeightPct": 1.75
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.2,
          "rightWeightPct": 1.72
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.2,
          "rightWeightPct": 1.72
        }
      ],
      "leftOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.33
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.29
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 1.19
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 1.12
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 1.12
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 1.09
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 1.02
        }
      ],
      "rightOnly": []
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-35",
      "sharedCount": 6,
      "leftOnlyCount": 12,
      "rightOnlyCount": 29,
      "leftSharedWeightPct": 72.38,
      "rightSharedWeightPct": 23.9,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 21.2,
          "rightWeightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 21.2,
          "rightWeightPct": 7
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 13.48,
          "rightWeightPct": 4.45
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 6.51,
          "rightWeightPct": 2.15
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 5.45,
          "rightWeightPct": 1.8
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "leftWeightPct": 4.54,
          "rightWeightPct": 1.5
        }
      ],
      "leftOnly": [
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "weightPct": 2.21
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "weightPct": 0.92
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "weightPct": 0.74
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "weightPct": 0.37
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.95
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-90",
      "sharedCount": 12,
      "leftOnlyCount": 6,
      "rightOnlyCount": 30,
      "leftSharedWeightPct": 27.62,
      "rightSharedWeightPct": 19.4,
      "shared": [
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 3.23
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "leftWeightPct": 3.13,
          "rightWeightPct": 2.2
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 2.95,
          "rightWeightPct": 2.07
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "leftWeightPct": 2.95,
          "rightWeightPct": 2.07
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 2.39,
          "rightWeightPct": 1.68
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 2.21,
          "rightWeightPct": 1.55
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "leftWeightPct": 1.66,
          "rightWeightPct": 1.16
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 1.1,
          "rightWeightPct": 0.78
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "leftWeightPct": 0.92,
          "rightWeightPct": 0.65
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.74,
          "rightWeightPct": 0.52
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.37,
          "rightWeightPct": 0.26
        }
      ],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 3.1
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-125",
      "sharedCount": 18,
      "leftOnlyCount": 0,
      "rightOnlyCount": 59,
      "leftSharedWeightPct": 100,
      "rightSharedWeightPct": 22.45,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 21.2,
          "rightWeightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 21.2,
          "rightWeightPct": 4.76
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 13.48,
          "rightWeightPct": 3.03
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 6.51,
          "rightWeightPct": 1.46
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 5.45,
          "rightWeightPct": 1.22
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 1.03
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 1.03
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "leftWeightPct": 4.54,
          "rightWeightPct": 1.02
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "leftWeightPct": 3.13,
          "rightWeightPct": 0.7
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 2.95,
          "rightWeightPct": 0.66
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "leftWeightPct": 2.95,
          "rightWeightPct": 0.66
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 2.39,
          "rightWeightPct": 0.54
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 2.21,
          "rightWeightPct": 0.5
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "leftWeightPct": 1.66,
          "rightWeightPct": 0.37
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 1.1,
          "rightWeightPct": 0.25
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "leftWeightPct": 0.92,
          "rightWeightPct": 0.21
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.74,
          "rightWeightPct": 0.17
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.37,
          "rightWeightPct": 0.08
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-banks",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-insurance",
      "sharedCount": 1,
      "leftOnlyCount": 17,
      "rightOnlyCount": 7,
      "leftSharedWeightPct": 1.1,
      "rightSharedWeightPct": 2.35,
      "shared": [
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 1.1,
          "rightWeightPct": 2.35
        }
      ],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ],
      "rightOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "ta-energy",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 13,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ],
      "rightOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ]
    },
    {
      "leftIndexId": "ta-technology",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 12,
      "leftOnlyCount": 6,
      "rightOnlyCount": 34,
      "leftSharedWeightPct": 85.7,
      "rightSharedWeightPct": 27.57,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 21.2,
          "rightWeightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 21.2,
          "rightWeightPct": 6.82
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 13.48,
          "rightWeightPct": 4.34
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 6.51,
          "rightWeightPct": 2.09
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 5.45,
          "rightWeightPct": 1.75
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 1.48
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 4.6,
          "rightWeightPct": 1.48
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 2.95,
          "rightWeightPct": 0.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 2.39,
          "rightWeightPct": 0.77
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 2.21,
          "rightWeightPct": 0.71
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.74,
          "rightWeightPct": 0.24
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.37,
          "rightWeightPct": 0.12
        }
      ],
      "leftOnly": [
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "weightPct": 0.92
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.72
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-35",
      "sharedCount": 5,
      "leftOnlyCount": 0,
      "rightOnlyCount": 30,
      "leftSharedWeightPct": 100.01,
      "rightSharedWeightPct": 24.15,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 7
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 19.88,
          "rightWeightPct": 4.8
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 14.08,
          "rightWeightPct": 3.4
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 8.07,
          "rightWeightPct": 1.95
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.15
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.9
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-90",
      "sharedCount": 0,
      "leftOnlyCount": 5,
      "rightOnlyCount": 42,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-125",
      "sharedCount": 5,
      "leftOnlyCount": 0,
      "rightOnlyCount": 72,
      "leftSharedWeightPct": 100.01,
      "rightSharedWeightPct": 16.42,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 4.76
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "leftWeightPct": 19.88,
          "rightWeightPct": 3.26
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "leftWeightPct": 14.08,
          "rightWeightPct": 2.31
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "leftWeightPct": 8.07,
          "rightWeightPct": 1.33
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 1.78
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-technology",
      "sharedCount": 0,
      "leftOnlyCount": 5,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-insurance",
      "sharedCount": 0,
      "leftOnlyCount": 5,
      "rightOnlyCount": 8,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 0,
      "leftOnlyCount": 5,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "ta-energy",
      "sharedCount": 0,
      "leftOnlyCount": 5,
      "rightOnlyCount": 13,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ]
    },
    {
      "leftIndexId": "ta-banks",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 2,
      "leftOnlyCount": 3,
      "rightOnlyCount": 44,
      "leftSharedWeightPct": 57.98,
      "rightSharedWeightPct": 13.64,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 28.99,
          "rightWeightPct": 6.82
        }
      ],
      "leftOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-35",
      "sharedCount": 5,
      "leftOnlyCount": 3,
      "rightOnlyCount": 30,
      "leftSharedWeightPct": 84.71,
      "rightSharedWeightPct": 13.15,
      "shared": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 25.45,
          "rightWeightPct": 3.95
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 20.29,
          "rightWeightPct": 3.15
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 17.07,
          "rightWeightPct": 2.65
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "leftWeightPct": 11.27,
          "rightWeightPct": 1.75
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "leftWeightPct": 10.63,
          "rightWeightPct": 1.65
        }
      ],
      "leftOnly": [
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.15
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-90",
      "sharedCount": 3,
      "leftOnlyCount": 5,
      "rightOnlyCount": 39,
      "leftSharedWeightPct": 15.28,
      "rightSharedWeightPct": 5.04,
      "shared": [
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 9.01,
          "rightWeightPct": 2.97
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "leftWeightPct": 3.92,
          "rightWeightPct": 1.29
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 2.35,
          "rightWeightPct": 0.78
        }
      ],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-125",
      "sharedCount": 8,
      "leftOnlyCount": 0,
      "rightOnlyCount": 69,
      "leftSharedWeightPct": 99.99,
      "rightSharedWeightPct": 10.55,
      "shared": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "leftWeightPct": 25.45,
          "rightWeightPct": 2.69
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "leftWeightPct": 20.29,
          "rightWeightPct": 2.14
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "leftWeightPct": 17.07,
          "rightWeightPct": 1.8
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "leftWeightPct": 11.27,
          "rightWeightPct": 1.19
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "leftWeightPct": 10.63,
          "rightWeightPct": 1.12
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "leftWeightPct": 9.01,
          "rightWeightPct": 0.95
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "leftWeightPct": 3.92,
          "rightWeightPct": 0.41
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 2.35,
          "rightWeightPct": 0.25
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 1.82
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-technology",
      "sharedCount": 1,
      "leftOnlyCount": 7,
      "rightOnlyCount": 17,
      "leftSharedWeightPct": 2.35,
      "rightSharedWeightPct": 1.1,
      "shared": [
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "leftWeightPct": 2.35,
          "rightWeightPct": 1.1
        }
      ],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-banks",
      "sharedCount": 0,
      "leftOnlyCount": 8,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 0,
      "leftOnlyCount": 8,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ],
      "rightOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "ta-energy",
      "sharedCount": 0,
      "leftOnlyCount": 8,
      "rightOnlyCount": 13,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ],
      "rightOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ]
    },
    {
      "leftIndexId": "ta-insurance",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 0,
      "leftOnlyCount": 8,
      "rightOnlyCount": 46,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-35",
      "sharedCount": 8,
      "leftOnlyCount": 10,
      "rightOnlyCount": 27,
      "leftSharedWeightPct": 52.74,
      "rightSharedWeightPct": 13.5,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 18.75,
          "rightWeightPct": 4.8
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 7.42,
          "rightWeightPct": 1.9
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "leftWeightPct": 6.25,
          "rightWeightPct": 1.6
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 5.86,
          "rightWeightPct": 1.5
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "leftWeightPct": 4.49,
          "rightWeightPct": 1.15
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 3.52,
          "rightWeightPct": 0.9
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 3.32,
          "rightWeightPct": 0.85
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "leftWeightPct": 3.13,
          "rightWeightPct": 0.8
        }
      ],
      "leftOnly": [
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 3.56
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "weightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "weightPct": 1.43
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.3
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.9
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-90",
      "sharedCount": 10,
      "leftOnlyCount": 8,
      "rightOnlyCount": 32,
      "leftSharedWeightPct": 47.27,
      "rightSharedWeightPct": 25.72,
      "shared": [
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 7.13,
          "rightWeightPct": 3.88
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 6.41,
          "rightWeightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 6.17,
          "rightWeightPct": 3.36
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 5.7,
          "rightWeightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 5.7,
          "rightWeightPct": 3.1
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 4.99,
          "rightWeightPct": 2.71
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 4.75,
          "rightWeightPct": 2.58
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "leftWeightPct": 3.56,
          "rightWeightPct": 1.94
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "leftWeightPct": 1.43,
          "rightWeightPct": 0.78
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "leftWeightPct": 1.43,
          "rightWeightPct": 0.78
        }
      ],
      "leftOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "weightPct": 3.52
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "weightPct": 3.32
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "weightPct": 3.13
        }
      ],
      "rightOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 3.62
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "weightPct": 2.97
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "weightPct": 2.45
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 2.33
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-125",
      "sharedCount": 18,
      "leftOnlyCount": 0,
      "rightOnlyCount": 59,
      "leftSharedWeightPct": 100.01,
      "rightSharedWeightPct": 17.4,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 18.75,
          "rightWeightPct": 3.26
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "leftWeightPct": 7.42,
          "rightWeightPct": 1.29
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 7.13,
          "rightWeightPct": 1.24
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "leftWeightPct": 6.41,
          "rightWeightPct": 1.12
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "leftWeightPct": 6.25,
          "rightWeightPct": 1.09
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 6.17,
          "rightWeightPct": 1.07
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 5.86,
          "rightWeightPct": 1.02
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 5.7,
          "rightWeightPct": 0.99
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 5.7,
          "rightWeightPct": 0.99
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "leftWeightPct": 4.99,
          "rightWeightPct": 0.87
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 4.75,
          "rightWeightPct": 0.83
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "leftWeightPct": 4.49,
          "rightWeightPct": 0.78
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "leftWeightPct": 3.56,
          "rightWeightPct": 0.62
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 3.52,
          "rightWeightPct": 0.61
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 3.32,
          "rightWeightPct": 0.58
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "leftWeightPct": 3.13,
          "rightWeightPct": 0.54
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "leftWeightPct": 1.43,
          "rightWeightPct": 0.25
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "leftWeightPct": 1.43,
          "rightWeightPct": 0.25
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 2.24
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 1.97
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-technology",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-banks",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-insurance",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 8,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "ta-energy",
      "sharedCount": 0,
      "leftOnlyCount": 18,
      "rightOnlyCount": 13,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ],
      "rightOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ]
    },
    {
      "leftIndexId": "ta-real-estate",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 9,
      "leftOnlyCount": 9,
      "rightOnlyCount": 37,
      "leftSharedWeightPct": 60.9,
      "rightSharedWeightPct": 15.19,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 18.75,
          "rightWeightPct": 4.68
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 7.13,
          "rightWeightPct": 1.78
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 6.17,
          "rightWeightPct": 1.54
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 5.86,
          "rightWeightPct": 1.46
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 5.7,
          "rightWeightPct": 1.42
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 5.7,
          "rightWeightPct": 1.42
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 4.75,
          "rightWeightPct": 1.18
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 3.52,
          "rightWeightPct": 0.88
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 3.32,
          "rightWeightPct": 0.83
        }
      ],
      "leftOnly": [
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 3.56
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "weightPct": 3.13
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "weightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "weightPct": 1.43
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-35",
      "sharedCount": 6,
      "leftOnlyCount": 7,
      "rightOnlyCount": 29,
      "leftSharedWeightPct": 49.58,
      "rightSharedWeightPct": 12.5,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 13.09,
          "rightWeightPct": 3.3
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 11.5,
          "rightWeightPct": 2.9
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 7.34,
          "rightWeightPct": 1.85
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 6.74,
          "rightWeightPct": 1.7
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 5.55,
          "rightWeightPct": 1.4
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 5.36,
          "rightWeightPct": 1.35
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "weightPct": 4.34
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.8
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.45
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-90",
      "sharedCount": 7,
      "leftOnlyCount": 6,
      "rightOnlyCount": 35,
      "leftSharedWeightPct": 50.41,
      "rightSharedWeightPct": 27.02,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 10.61,
          "rightWeightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 10.37,
          "rightWeightPct": 5.56
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 7,
          "rightWeightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 7,
          "rightWeightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 6.75,
          "rightWeightPct": 3.62
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 4.34,
          "rightWeightPct": 2.33
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 4.34,
          "rightWeightPct": 2.33
        }
      ],
      "leftOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        }
      ],
      "rightOnly": [
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 3.88
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 3.1
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "weightPct": 2.97
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 2.71
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 2.58
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-125",
      "sharedCount": 13,
      "leftOnlyCount": 0,
      "rightOnlyCount": 64,
      "leftSharedWeightPct": 99.99,
      "rightSharedWeightPct": 17.14,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 13.09,
          "rightWeightPct": 2.24
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 11.5,
          "rightWeightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 10.61,
          "rightWeightPct": 1.82
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 10.37,
          "rightWeightPct": 1.78
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 7.34,
          "rightWeightPct": 1.26
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 7,
          "rightWeightPct": 1.2
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 7,
          "rightWeightPct": 1.2
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 6.75,
          "rightWeightPct": 1.16
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 6.74,
          "rightWeightPct": 1.16
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 5.55,
          "rightWeightPct": 0.95
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 5.36,
          "rightWeightPct": 0.92
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 4.34,
          "rightWeightPct": 0.74
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 4.34,
          "rightWeightPct": 0.74
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 3.26
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 3.03
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-technology",
      "sharedCount": 0,
      "leftOnlyCount": 13,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ],
      "rightOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 4.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "weightPct": 2.95
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "weightPct": 2.39
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-banks",
      "sharedCount": 0,
      "leftOnlyCount": 13,
      "rightOnlyCount": 5,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 28.99
        },
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-insurance",
      "sharedCount": 0,
      "leftOnlyCount": 13,
      "rightOnlyCount": 8,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 0,
      "leftOnlyCount": 13,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 7
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 6.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "weightPct": 6.74
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "weightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "weightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "weightPct": 4.34
        }
      ],
      "rightOnly": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 18.75
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 7.13
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "weightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 5.7
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "weightPct": 4.75
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        }
      ]
    },
    {
      "leftIndexId": "ta-energy",
      "rightIndexId": "defense-watchlist",
      "sharedCount": 13,
      "leftOnlyCount": 0,
      "rightOnlyCount": 33,
      "leftSharedWeightPct": 99.99,
      "rightSharedWeightPct": 24.59,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 13.09,
          "rightWeightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 11.5,
          "rightWeightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 10.61,
          "rightWeightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 10.37,
          "rightWeightPct": 2.55
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 7.34,
          "rightWeightPct": 1.8
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 7,
          "rightWeightPct": 1.72
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 7,
          "rightWeightPct": 1.72
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 6.75,
          "rightWeightPct": 1.66
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 6.74,
          "rightWeightPct": 1.66
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 5.55,
          "rightWeightPct": 1.36
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 5.36,
          "rightWeightPct": 1.32
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 4.34,
          "rightWeightPct": 1.07
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 4.34,
          "rightWeightPct": 1.07
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 1.75
        },
        {
          "id": "bezq",
          "name": "Bezeq",
          "ticker": "BEZQ",
          "weightPct": 1.7
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-35",
      "sharedCount": 22,
      "leftOnlyCount": 24,
      "rightOnlyCount": 13,
      "leftSharedWeightPct": 67.96,
      "rightSharedWeightPct": 69.75,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 7
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 7
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 6.82,
          "rightWeightPct": 7
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 6.82,
          "rightWeightPct": 7
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 6.82,
          "rightWeightPct": 7
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.68,
          "rightWeightPct": 4.8
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.34,
          "rightWeightPct": 4.45
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.22,
          "rightWeightPct": 3.3
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.83,
          "rightWeightPct": 2.9
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.09,
          "rightWeightPct": 2.15
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.8,
          "rightWeightPct": 1.85
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.75,
          "rightWeightPct": 1.8
        },
        {
          "id": "bezq",
          "name": "Bezeq",
          "ticker": "BEZQ",
          "leftWeightPct": 1.7,
          "rightWeightPct": 1.75
        },
        {
          "id": "icl",
          "name": "ICL Group",
          "ticker": "ICL",
          "leftWeightPct": 1.7,
          "rightWeightPct": 1.75
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 1.66,
          "rightWeightPct": 1.7
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 1.46,
          "rightWeightPct": 1.5
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 1.36,
          "rightWeightPct": 1.4
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 1.32,
          "rightWeightPct": 1.35
        }
      ],
      "leftOnly": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.72
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "weightPct": 1.72
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "weightPct": 1.66
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "weightPct": 1.54
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "weightPct": 1.48
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "weightPct": 1.48
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "weightPct": 1.42
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "weightPct": 1.42
        }
      ],
      "rightOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 4.8
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 3.95
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 3.4
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 3.15
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 2.65
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.95
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.9
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 1.75
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 1.65
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 1.6
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 1.5
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 1.15
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-90",
      "sharedCount": 24,
      "leftOnlyCount": 22,
      "rightOnlyCount": 18,
      "leftSharedWeightPct": 32.07,
      "rightSharedWeightPct": 69.93,
      "shared": [
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 2.61,
          "rightWeightPct": 5.68
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 2.55,
          "rightWeightPct": 5.56
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 2.13,
          "rightWeightPct": 4.65
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.78,
          "rightWeightPct": 3.88
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.72,
          "rightWeightPct": 3.75
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.72,
          "rightWeightPct": 3.75
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 1.66,
          "rightWeightPct": 3.62
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 1.54,
          "rightWeightPct": 3.36
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 1.48,
          "rightWeightPct": 3.23
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 1.48,
          "rightWeightPct": 3.23
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 1.42,
          "rightWeightPct": 3.1
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 1.42,
          "rightWeightPct": 3.1
        },
        {
          "id": "ptnr",
          "name": "Partner Communications",
          "ticker": "PTNR",
          "leftWeightPct": 1.36,
          "rightWeightPct": 2.97
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 1.18,
          "rightWeightPct": 2.58
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 1.07,
          "rightWeightPct": 2.33
        },
        {
          "id": "cel",
          "name": "Cellcom Israel",
          "ticker": "CEL",
          "leftWeightPct": 1.07,
          "rightWeightPct": 2.33
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 1.07,
          "rightWeightPct": 2.33
        },
        {
          "id": "rmli",
          "name": "Rami Levy",
          "ticker": "RMLI",
          "leftWeightPct": 1.01,
          "rightWeightPct": 2.2
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 1.75
        }
      ],
      "rightOnly": [
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 3.49
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 2.97
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 2.71
        },
        {
          "id": "ilco",
          "name": "Israel Corporation",
          "ticker": "ILCO",
          "weightPct": 2.45
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 2.2
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.07
        },
        {
          "id": "delg",
          "name": "Delta Galil",
          "ticker": "DELG",
          "weightPct": 1.94
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 1.94
        },
        {
          "id": "fox",
          "name": "Fox Wizel",
          "ticker": "FOX",
          "weightPct": 1.81
        },
        {
          "id": "mtrn",
          "name": "Maytronics",
          "ticker": "MTRN",
          "weightPct": 1.55
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 1.29
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.16
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-125",
      "sharedCount": 46,
      "leftOnlyCount": 0,
      "rightOnlyCount": 31,
      "leftSharedWeightPct": 100.03,
      "rightSharedWeightPct": 69.78,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 4.76
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 4.76
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 6.82,
          "rightWeightPct": 4.76
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "leftWeightPct": 6.82,
          "rightWeightPct": 4.76
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 6.82,
          "rightWeightPct": 4.76
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.68,
          "rightWeightPct": 3.26
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.34,
          "rightWeightPct": 3.03
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.22,
          "rightWeightPct": 2.24
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.83,
          "rightWeightPct": 1.97
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 2.61,
          "rightWeightPct": 1.82
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 2.55,
          "rightWeightPct": 1.78
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "leftWeightPct": 2.13,
          "rightWeightPct": 1.49
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.09,
          "rightWeightPct": 1.46
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.8,
          "rightWeightPct": 1.26
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.78,
          "rightWeightPct": 1.24
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.75,
          "rightWeightPct": 1.22
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.72,
          "rightWeightPct": 1.2
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.72,
          "rightWeightPct": 1.2
        }
      ],
      "leftOnly": [],
      "rightOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 3.26
        },
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 2.69
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 2.31
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 2.14
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 1.8
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 1.33
        },
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 1.29
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 1.19
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 1.12
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 1.12
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 1.09
        },
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 1.02
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-technology",
      "sharedCount": 12,
      "leftOnlyCount": 34,
      "rightOnlyCount": 6,
      "leftSharedWeightPct": 27.57,
      "rightSharedWeightPct": 85.7,
      "shared": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "leftWeightPct": 6.82,
          "rightWeightPct": 21.2
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "leftWeightPct": 6.82,
          "rightWeightPct": 21.2
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "leftWeightPct": 4.34,
          "rightWeightPct": 13.48
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "leftWeightPct": 2.09,
          "rightWeightPct": 6.51
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "leftWeightPct": 1.75,
          "rightWeightPct": 5.45
        },
        {
          "id": "mtrx",
          "name": "Matrix IT",
          "ticker": "MTRX",
          "leftWeightPct": 1.48,
          "rightWeightPct": 4.6
        },
        {
          "id": "nyax",
          "name": "Nayax",
          "ticker": "NYAX",
          "leftWeightPct": 1.48,
          "rightWeightPct": 4.6
        },
        {
          "id": "hlan",
          "name": "Hilan",
          "ticker": "HLAN",
          "leftWeightPct": 0.95,
          "rightWeightPct": 2.95
        },
        {
          "id": "iscd",
          "name": "Isracard",
          "ticker": "ISCD",
          "leftWeightPct": 0.77,
          "rightWeightPct": 2.39
        },
        {
          "id": "prtc",
          "name": "Priortech",
          "ticker": "PRTC",
          "leftWeightPct": 0.71,
          "rightWeightPct": 2.21
        },
        {
          "id": "audc",
          "name": "AudioCodes",
          "ticker": "AUDC",
          "leftWeightPct": 0.24,
          "rightWeightPct": 0.74
        },
        {
          "id": "bvc",
          "name": "BATM Advanced Communications",
          "ticker": "BVC",
          "leftWeightPct": 0.12,
          "rightWeightPct": 0.37
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "weightPct": 1.72
        }
      ],
      "rightOnly": [
        {
          "id": "nice",
          "name": "NICE",
          "ticker": "NICE",
          "weightPct": 4.54
        },
        {
          "id": "forty",
          "name": "Formula Systems",
          "ticker": "FORTY",
          "weightPct": 3.13
        },
        {
          "id": "one",
          "name": "One Software Technologies",
          "ticker": "ONE",
          "weightPct": 2.95
        },
        {
          "id": "mltm",
          "name": "Malam Team",
          "ticker": "MLTM",
          "weightPct": 1.66
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 1.1
        },
        {
          "id": "peri",
          "name": "Perion Network",
          "ticker": "PERI",
          "weightPct": 0.92
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-banks",
      "sharedCount": 2,
      "leftOnlyCount": 44,
      "rightOnlyCount": 3,
      "leftSharedWeightPct": 13.64,
      "rightSharedWeightPct": 57.98,
      "shared": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 28.99
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "leftWeightPct": 6.82,
          "rightWeightPct": 28.99
        }
      ],
      "leftOnly": [
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "weightPct": 1.8
        }
      ],
      "rightOnly": [
        {
          "id": "mztf",
          "name": "Mizrahi Tefahot Bank",
          "ticker": "MZTF",
          "weightPct": 19.88
        },
        {
          "id": "dsct",
          "name": "Israel Discount Bank",
          "ticker": "DSCT",
          "weightPct": 14.08
        },
        {
          "id": "fibi",
          "name": "First International Bank of Israel",
          "ticker": "FIBI",
          "weightPct": 8.07
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-insurance",
      "sharedCount": 0,
      "leftOnlyCount": 46,
      "rightOnlyCount": 8,
      "leftSharedWeightPct": 0,
      "rightSharedWeightPct": 0,
      "shared": [],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        }
      ],
      "rightOnly": [
        {
          "id": "phoe",
          "name": "Phoenix Financial",
          "ticker": "PHOE",
          "weightPct": 25.45
        },
        {
          "id": "harl",
          "name": "Harel Insurance Investments",
          "ticker": "HARL",
          "weightPct": 20.29
        },
        {
          "id": "mmhd",
          "name": "Menora Mivtachim Holdings",
          "ticker": "MMHD",
          "weightPct": 17.07
        },
        {
          "id": "clis",
          "name": "Clal Insurance Enterprises",
          "ticker": "CLIS",
          "weightPct": 11.27
        },
        {
          "id": "mgdl",
          "name": "Migdal Insurance and Financial Holdings",
          "ticker": "MGDL",
          "weightPct": 10.63
        },
        {
          "id": "ibi",
          "name": "IBI Investment House",
          "ticker": "IBI",
          "weightPct": 9.01
        },
        {
          "id": "mrin",
          "name": "More Investment House",
          "ticker": "MRIN",
          "weightPct": 3.92
        },
        {
          "id": "difi",
          "name": "Direct Finance",
          "ticker": "DIFI",
          "weightPct": 2.35
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-real-estate",
      "sharedCount": 9,
      "leftOnlyCount": 37,
      "rightOnlyCount": 9,
      "leftSharedWeightPct": 15.19,
      "rightSharedWeightPct": 60.9,
      "shared": [
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "leftWeightPct": 4.68,
          "rightWeightPct": 18.75
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "leftWeightPct": 1.78,
          "rightWeightPct": 7.13
        },
        {
          "id": "gvym",
          "name": "Bayside Land Corporation (Gav-Yam)",
          "ticker": "GVYM",
          "leftWeightPct": 1.54,
          "rightWeightPct": 6.17
        },
        {
          "id": "spen",
          "name": "Shapir Engineering",
          "ticker": "SPEN",
          "leftWeightPct": 1.46,
          "rightWeightPct": 5.86
        },
        {
          "id": "alhe",
          "name": "Alony Hetz",
          "ticker": "ALHE",
          "leftWeightPct": 1.42,
          "rightWeightPct": 5.7
        },
        {
          "id": "ashg",
          "name": "Ashtrom Group",
          "ticker": "ASHG",
          "leftWeightPct": 1.42,
          "rightWeightPct": 5.7
        },
        {
          "id": "arpt",
          "name": "Airport City",
          "ticker": "ARPT",
          "leftWeightPct": 1.18,
          "rightWeightPct": 4.75
        },
        {
          "id": "mvne",
          "name": "Mivne Real Estate",
          "ticker": "MVNE",
          "leftWeightPct": 0.88,
          "rightWeightPct": 3.52
        },
        {
          "id": "amot",
          "name": "Amot Investments",
          "ticker": "AMOT",
          "leftWeightPct": 0.83,
          "rightWeightPct": 3.32
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "weightPct": 3.22
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "weightPct": 2.83
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "weightPct": 2.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "weightPct": 2.55
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        }
      ],
      "rightOnly": [
        {
          "id": "mlsr",
          "name": "Melisron",
          "ticker": "MLSR",
          "weightPct": 7.42
        },
        {
          "id": "afpr",
          "name": "AFI Properties",
          "ticker": "AFPR",
          "weightPct": 6.41
        },
        {
          "id": "big",
          "name": "Big Shopping Centers",
          "ticker": "BIG",
          "weightPct": 6.25
        },
        {
          "id": "iscn",
          "name": "Israel Canada",
          "ticker": "ISCN",
          "weightPct": 4.99
        },
        {
          "id": "ftal",
          "name": "Fattal Holdings",
          "ticker": "FTAL",
          "weightPct": 4.49
        },
        {
          "id": "rit1",
          "name": "REIT 1",
          "ticker": "RIT1",
          "weightPct": 3.56
        },
        {
          "id": "dimri",
          "name": "Y.H. Dimri Construction and Development",
          "ticker": "DIMRI",
          "weightPct": 3.13
        },
        {
          "id": "gct",
          "name": "G City",
          "ticker": "GCT",
          "weightPct": 1.43
        },
        {
          "id": "slarl",
          "name": "Sella Capital",
          "ticker": "SLARL",
          "weightPct": 1.43
        }
      ]
    },
    {
      "leftIndexId": "defense-watchlist",
      "rightIndexId": "ta-energy",
      "sharedCount": 13,
      "leftOnlyCount": 33,
      "rightOnlyCount": 0,
      "leftSharedWeightPct": 24.59,
      "rightSharedWeightPct": 99.99,
      "shared": [
        {
          "id": "enlt",
          "name": "Enlight Renewable Energy",
          "ticker": "ENLT",
          "leftWeightPct": 3.22,
          "rightWeightPct": 13.09
        },
        {
          "id": "opce",
          "name": "OPC Energy",
          "ticker": "OPCE",
          "leftWeightPct": 2.83,
          "rightWeightPct": 11.5
        },
        {
          "id": "dorl",
          "name": "Doral Group",
          "ticker": "DORL",
          "leftWeightPct": 2.61,
          "rightWeightPct": 10.61
        },
        {
          "id": "enrg",
          "name": "Energix",
          "ticker": "ENRG",
          "leftWeightPct": 2.55,
          "rightWeightPct": 10.37
        },
        {
          "id": "ora",
          "name": "Ormat Technologies",
          "ticker": "ORA",
          "leftWeightPct": 1.8,
          "rightWeightPct": 7.34
        },
        {
          "id": "enog",
          "name": "Energean",
          "ticker": "ENOG",
          "leftWeightPct": 1.72,
          "rightWeightPct": 7
        },
        {
          "id": "nofr",
          "name": "Nofar Energy",
          "ticker": "NOFR",
          "leftWeightPct": 1.72,
          "rightWeightPct": 7
        },
        {
          "id": "nwmd",
          "name": "NewMed Energy",
          "ticker": "NWMD",
          "leftWeightPct": 1.66,
          "rightWeightPct": 6.74
        },
        {
          "id": "paz",
          "name": "Paz Retail and Energy",
          "ticker": "PAZ",
          "leftWeightPct": 1.66,
          "rightWeightPct": 6.75
        },
        {
          "id": "dlekg",
          "name": "Delek Group",
          "ticker": "DLEKG",
          "leftWeightPct": 1.36,
          "rightWeightPct": 5.55
        },
        {
          "id": "nvpt",
          "name": "Navitas Petroleum",
          "ticker": "NVPT",
          "leftWeightPct": 1.32,
          "rightWeightPct": 5.36
        },
        {
          "id": "orl",
          "name": "Bazan",
          "ticker": "ORL",
          "leftWeightPct": 1.07,
          "rightWeightPct": 4.34
        },
        {
          "id": "ken",
          "name": "Kenon Holdings",
          "ticker": "KEN",
          "leftWeightPct": 1.07,
          "rightWeightPct": 4.34
        }
      ],
      "leftOnly": [
        {
          "id": "poli",
          "name": "Bank Hapoalim",
          "ticker": "POLI",
          "weightPct": 6.82
        },
        {
          "id": "lumi",
          "name": "Bank Leumi Le-Israel",
          "ticker": "LUMI",
          "weightPct": 6.82
        },
        {
          "id": "eslt",
          "name": "Elbit Systems",
          "ticker": "ESLT",
          "weightPct": 6.82
        },
        {
          "id": "teva",
          "name": "Teva Pharmaceutical Industries",
          "ticker": "TEVA",
          "weightPct": 6.82
        },
        {
          "id": "tsem",
          "name": "Tower Semiconductor",
          "ticker": "TSEM",
          "weightPct": 6.82
        },
        {
          "id": "azrg",
          "name": "Azrieli Group",
          "ticker": "AZRG",
          "weightPct": 4.68
        },
        {
          "id": "nvmi",
          "name": "Nova",
          "ticker": "NVMI",
          "weightPct": 4.34
        },
        {
          "id": "tase",
          "name": "TASE",
          "ticker": "TASE",
          "weightPct": 2.13
        },
        {
          "id": "nxsn",
          "name": "NextVision Stabilized Systems",
          "ticker": "NXSN",
          "weightPct": 2.09
        },
        {
          "id": "eltr",
          "name": "Electra",
          "ticker": "ELTR",
          "weightPct": 1.78
        },
        {
          "id": "camt",
          "name": "Camtek",
          "ticker": "CAMT",
          "weightPct": 1.75
        },
        {
          "id": "bezq",
          "name": "Bezeq",
          "ticker": "BEZQ",
          "weightPct": 1.7
        }
      ],
      "rightOnly": []
    }
  ],
  "sources": [
    {
      "id": "tase-ta35",
      "title": "TASE TA-35 index page",
      "publisher": "Tel Aviv Stock Exchange",
      "url": "https://market.tase.co.il/en/market_data/index/142/about",
      "note": "Official index page used for source attribution and point-in-time cross-checking."
    },
    {
      "id": "tase-ta90",
      "title": "TASE TA-90 index page",
      "publisher": "Tel Aviv Stock Exchange",
      "url": "https://market.tase.co.il/en/market_data/index/137/about",
      "note": "Official index page used for source attribution and point-in-time cross-checking."
    },
    {
      "id": "tase-data-services",
      "title": "TASE Data Services",
      "publisher": "Tel Aviv Stock Exchange",
      "url": "https://www.tase.co.il/en/content/products_lobby/data_services",
      "note": "Official data-services page documenting TASE data products and access paths."
    },
    {
      "id": "tase-data-hub-api",
      "title": "TASE Data Hub API guide",
      "publisher": "Tel Aviv Stock Exchange",
      "url": "https://content.tase.co.il/media/l5xjhjmz/2000_api_guide_eng.pdf",
      "note": "Official guide for Data Hub API usage. Live or delayed market-data integrations require approved access and must not expose credentials in the browser."
    },
    {
      "id": "local-curation",
      "title": "Claw & Talon static research seed",
      "publisher": "Claw & Talon",
      "url": "https://clawandtalon.capital/tase-index-constituents",
      "note": "Local point-in-time research dataset used to power the static explorer. It is not a live quote feed or licensed redistribution of official TASE constituent exports."
    }
  ],
  "methodology": {
    "weightPolicy": "Base TA-35 and TA-90 weights are normalized from the local seed file. TA-125 is derived as a 68% TA-35 / 32% TA-90 tracked-universe blend. Sector and theme lenses normalize the relevant subset to 100%. The build fails if any normalized weight exceeds the TASE single-constituent caps (7% in TA-35, 5% in TA-125), mirroring official index rules.",
    "profileLinkPolicy": "Profile links are attached only when a constituent matches an existing Claw & Talon startup/public-company profile slug or explicit seed mapping.",
    "apiPolicy": "Official TASE Data Hub/API access can be used build-time in the future, but credentials and licensed market data must not be fetched directly from the public browser client."
  }
}
